import { EventEmitter } from "events";
import dispatcher from "../dispatchers/dispatcher";
import ExpenseStores from "./expensestore";
import UserInfoStores from "./userInfoStores";
import Common from "../constants/common";
import moment from "moment";
import GenericContainerTypeStore from "./genericContainerTypeStore";
import { isJson, isObject } from "../constants/is";
import history from "helper/history";

import i18n from "../i18nNext";
Math.roundOff = (val, decimal) => {
    if (typeof val !== "number" && isNaN(+val)) {
        return val;
    } else if (typeof val !== "number" && !isNaN(+val)) {
        val = +val;
    }
    return parseFloat(val.toFixed(decimal));
};

class ExtraFieldStores extends EventEmitter {
    constructor() {
        super();
        this.initData();
    }
    initData() {
        this.extraFields = {};
        this.extraFieldMap = {};
        this.preDefinedExtraFields = [];
        this.expressionExtraFieldObject = {};
        this.result = "";
        this.overrideFields = [];
        this.res_code = -1;
        this.extraFieldTypes = [];
        this.transactionEF = {};
        this.particularEf = {};
        this.efResources = {};
        this.extrafieldRunningMap = {};
        this.extraFieldNative = {};
        this.extraFieldNativeDependentFields = [];
        this.setAllSearchableData = {};
        this.invite_user_ef_values = {};
        this.mapForExpressionExtraField = {};
        this.operation = "";
        this.contentTypeMap = {};
        this.efMapforExpressionOrComposite = {};
        this.reverseMap = {};
        this.expressionObj = {};
        this.expressionValid = false;
        this.current_txn_type = "";
        this.initialExtrafieldValues = {};
        this.mode = "create";
        this._initRouteTracker();
        this.containerMappedFields = [];
        this.ocrFilledFields = [];
        this.concatMappedFields = {};
        this.decimalPlace = "";
        this.constantsArrayLength = 0;
        this.ifscErrMsg = '';
        this.searchableDataContentRelation = {};
    }

    _isEFConfigExists(type) {
        return type in this.extraFields;
    }

    _setCurrentTxnType(txnType) {
        this.current_txn_type = txnType;
    }

    _initRouteTracker() {
        this.routeTrackerInfo = {
            current: {},
            actual: {}
        };
    }

    _setMode(type, typeCheck) {
        if (type && type !== typeCheck) {
            this.mode = "edit";
        } else {
            this.mode = "create";
        }
    }

    _getMode() {
        return this.mode;
    }

    _resetRouteTrackerInfo(txnType) {
        this.routeTrackerInfo = {
            ...this.routeTrackerInfo,
            current: { [txnType]: {} } // after submit
        };
    }

    _setDistanceUnitInRouteTrackerInfo(id, val) {
        const {
            current: { [id]: { distanceUnit } = {} }
        } = this.routeTrackerInfo;
        if (distanceUnit) {
            this.routeTrackerInfo["current"][id]["distanceUnit"] = val;
        } else {
            if (!this.routeTrackerInfo["current"]?.[id]) {
                this.routeTrackerInfo["current"][id] = {};
            }
            this.routeTrackerInfo["current"][id]["distanceUnit"] = val;
        }
    }

    _setRouteTrackerInfo(...args) {
        const [id, ...rest] = args;
        const [
            completeInfo,
            metadata,
            ref,
            distanceUnit = this.routeTrackerInfo?.current?.[id]?.distanceUnit,
            otherInfo
        ] = rest;

        const obj = { completeInfo, metadata, ref, distanceUnit, otherInfo };
        if (this.routeTrackerInfo.current[id]) {
            this.routeTrackerInfo.current[id] = obj;
        } else {
            this.routeTrackerInfo.current = { [id]: obj };
        }
    }

    _getRouteTrackerInfo(txnType, type) {
        if (type) {
            return this.routeTrackerInfo[type][txnType] || {};
        }
        return this.routeTrackerInfo.actual[txnType] || {};
    }

    _cancelRouteTrackerInfo(txnType) {
        const {
            actual: { [txnType]: { metadata } = {} }
        } = this.routeTrackerInfo;

        this.routeTrackerInfo = {
            ...this.routeTrackerInfo,
            current: !metadata
                ? {}
                : {
                      [txnType]: {
                          ...this.routeTrackerInfo.current[txnType],
                          metadata: [...metadata]
                      }
                  }
        };
    }

    _submitRouteTrackerInfo(txnType) {
        this.routeTrackerInfo = {
            ...this.routeTrackerInfo,
            actual: {
                [txnType]: {
                    ...this.routeTrackerInfo.current[txnType],
                    tripID: new Date().getTime()
                }
            }
        };
    }

    _setRouteTrackerActualInfo(...args) {
        const [id, obj] = args;
        this.routeTrackerInfo = { ...this.routeTrackerInfo, actual: { [id]: { metadata: obj } } };
    }

    _formatDate(date, format) {
        let finalDateFormat = moment
            .utc(date || undefined)
            .local()
            .format(format || "lll");
        return finalDateFormat;
    }
    _getTransactionExtraField(txnef, isContainer) {
        if (isContainer) {
            this.containerEF = txnef;
            this.emit("change", "containerEF");
        } else {
            this.transactionEF = txnef;
            this.emit("change", "transactionextrafield");
        }
    }
    _getAllContainerEF() {
        return this.containerEF;
    }

    _setEFValuesForInvite(data) {
        this.invite_user_ef_values = data;
        this.emit("change", "invite_ef_values");
    }

    _getInviteEFvalues() {
        return this.invite_user_ef_values;
    }

    _getMessage() {
        return this.result;
    }
    _getResCode() {
        return this.res_code;
    }
    _resetExpressionExtraField() {
        this.expressionExtraFieldObject["txn_expression"] = [];
    }
    _getExtraFieldTypes(extraFieldTypes) {
        this.extraFieldTypes = extraFieldTypes;
        this.emit("change", "extraFieldTypes");
    }

    _setExtraFieldTypes() {
        return this.extraFieldTypes;
    }
    _setAllTransactionExtraField(tId) {
        if (tId) return this.transactionEF[tId] || {};
        return this.transactionEF;
    }
    _setTransactionExtraField() {
        let key = Object.keys(this.transactionEF) ? Object.keys(this.transactionEF)[0] : "";
        let objInfo = this.transactionEF[key];
        return objInfo;
    }
    _calExtrafieldExpressionValue(ef) {
        let expressionToEval = ef && ef.is_expression["expression"];
        const compositeObj = {};
        this.extrafieldRunningMap["transaction"] &&
            expressionToEval.split(",").forEach((e, i) => {
                if (e !== ")" && e !== "(") {
                    if (e.includes("constant")) {
                        compositeObj[i] = ef.is_expression[e];
                    } else if (!isNaN(+e)) {
                        compositeObj[i] = e;
                    } else if (e in ef.is_expression) {
                        compositeObj[i] =
                            this.extrafieldRunningMap["transaction"][ef.is_expression[e]] ||
                            this.extrafieldRunningMap["txn_expression"][ef.is_expression[e]] ||
                            "0";
                    } else if (["+", "*", "-", "/", "%"].includes(e)) {
                        compositeObj[i] = e;
                    } else if (e.includes("round")) {
                        compositeObj[i] = "Math.roundOff(";
                    }
                }
            });
        let evalExpr = Object.values(compositeObj).join("");
        // console.log(214, evalExpr);
        if (evalExpr.includes("Math.roundOff(")) {
            evalExpr += ")";
        }

        /*
        this.extrafieldRunningMap["transaction"] &&
            expressionToEval.split(",").map(el => {
                if (!["(", ")", "+", "-", "*", "/"].includes(el)) {
                    if (el.includes("constant")) {
                        expressionToEval = expressionToEval.replace(el, ef.is_expression[el]);
                    } else if (el.includes("round")) {
                        expressionToEval = expressionToEval.replace(el, "Math.roundOff");
                    } else if (
                        !Object.keys(this.extrafieldRunningMap["transaction"]).includes(
                            ef.is_expression[el]
                        )
                    ) {
                        // if(!this.visibleEF.has(ef.is_expression[el])){
                        let val = "";
                        let backwardsign = expressionToEval.split(",")[
                            expressionToEval.split(",").indexOf(el) + 1
                        ];
                        let forwardsign = expressionToEval.split(",")[
                            expressionToEval.split(",").indexOf(el) - 1
                        ];
                        if (
                            backwardsign === "*" ||
                            forwardsign === "*" ||
                            backwardsign === "/" ||
                            forwardsign === "/"
                        )
                            val = "1";
                        else val = "0";
                        expressionToEval = expressionToEval.replace(el, val);
                    } else {
                        if (
                            this.extrafieldRunningMap["transaction"][ef.is_expression[el]] &&
                            this.extrafieldRunningMap["transaction"][ef.is_expression[el]] !== ""
                        )
                            expressionToEval = expressionToEval.replace(
                                el,
                                this.extrafieldRunningMap["transaction"][ef.is_expression[el]]
                            );
                        else expressionToEval = expressionToEval.replace(el, "0");
                    }
                }
            });
        */
        if (!this.extrafieldRunningMap["transaction"]) {
            this.extrafieldRunningMap["transaction"] = {};
        }
        if (!this.extrafieldRunningMap["txn_expression"]) {
            this.extrafieldRunningMap["txn_expression"] = {};
        }
        try {
            this.extrafieldRunningMap["txn_expression"][ef.field_id] = eval(evalExpr) || "0";
            this.extrafieldRunningMap["transaction"][ef.field_id] = eval(evalExpr) || "0";
        } catch (e) {
            this.extrafieldRunningMap["txn_expression"][ef.field_id] = "0";
            this.extrafieldRunningMap["transaction"][ef.field_id] = "0";
        }
    }
    _setExpressionExtraField(expObj, fromFn) {
        if (fromFn == "setObj") {
            this.extraFields["txn_expression"] = expObj;
            let exp_value = ExpenseStores._getTransactionData();
            this.extraFieldNative["txn_type"] = this.extraFieldNative["txn_type"] || [];
            this.expressionExtraFieldObject["txn_expression"] = expObj;
            let extrafieldData = {};
            //Add expense in a calculated type of txn
            if (Object.keys(exp_value).length === 0) {
                let ef = this.expressionExtraFieldObject["txn_expression"];
                this.extrafieldRunningMap["txn_expression"] = {};
                for (let i = 0; i < ef.length; i++) {
                    const { default_selected_value, name_type, field_id, is_dependent_on } = ef[i];
                    if (
                        default_selected_value &&
                        ["dropdown", "multi_select_dropdown"].includes(name_type)
                    ) {
                        try {
                            const val = JSON.parse(default_selected_value);
                            if (
                                is_dependent_on &&
                                is_dependent_on.field === "extraField" &&
                                isJson(val)
                            ) {
                                this.extrafieldRunningMap["txn_expression"][field_id] =
                                    val[
                                        this.extrafieldRunningMap["transaction"][is_dependent_on.id]
                                    ] || "";
                            } else {
                                this.extrafieldRunningMap["txn_expression"][field_id] =
                                    val[this.current_txn_type];
                            }
                        } catch (error) {
                            this.extrafieldRunningMap["txn_expression"][ef[i].field_id] = "";
                        }
                    } else if (
                        ef[i].default_selected_value &&
                        ["number", "text", "IFSC", "BACC"].includes(ef[i].name_type)
                    ) {

                        this.extrafieldRunningMap["txn_expression"][ef[i].field_id] =
                            ef[i].default_selected_value;
                    } else if (
                        !ef[i].default_selected_value &&
                        ["number", "text", "IFSC", "BACC"].includes(ef[i].name_type)
                    ) {
                        try {
                            let val = JSON.parse(ef[i].values);
                            this.extrafieldRunningMap["txn_expression"][ef[i].field_id] =
                                val[this.current_txn_type];
                        } catch (error) {
                            this.extrafieldRunningMap["txn_expression"][ef[i].field_id] = "";
                        }
                    } else {
                        this.extrafieldRunningMap["txn_expression"][ef[i].field_id] = "";
                    }
                    if (
                        this.extraFieldNative["txn_type"] &&
                        !this.extraFieldNative["txn_type"].includes(ef[i].field_id)
                    )
                        this.extraFieldNative["txn_type"].push(ef[i].field_id);
                }
            } else {
                //Edit expense in a calculated type of txn
                let ef ={};
                try {
                    ef = exp_value.extra_field.extra_fields[exp_value.transaction.txn_id];
                } catch(e){
                    // This is the case when we are calling this function form _setParsedData to set this EF.
                    // This is only because we are getting the data from the backend in this format only.
                    ef = exp_value?.extra_field || {};
                }
                let txn_exp = this.expressionExtraFieldObject["txn_expression"];
                for (let i in txn_exp) {
                    if (ef && ef[txn_exp[i].name])
                        if (
                            ef[txn_exp[i].name].name_type === "date" ||
                            ef[txn_exp[i].name].name_type === "last_working_day"
                        )
                            txn_exp[i].fieldValue = ef[txn_exp[i].name].field_value
                                ? new Date(ef[txn_exp[i].name].field_value)
                                : {};
                        else txn_exp[i].fieldValue = ef[txn_exp[i].name].field_value;
                }
                this.expressionExtraFieldObject["txn_expression"] = txn_exp;
                let efs = this.expressionExtraFieldObject["txn_expression"];
                for (let i = 0; i < efs.length; i++) {
                    if (
                        this.extraFieldNative["txn_type"] &&
                        !this.extraFieldNative["txn_type"].includes(efs[i].field_id)
                    )
                        this.extraFieldNative["txn_type"].push(efs[i].field_id);
                    extrafieldData[efs[i].field_id] = efs[i].fieldValue;
                }
            }
            let childParent = this._getChildParentMap("txn_expression") || [];
            let efRM = this._getExtraFieldRunningMap("transaction");
            for (let i in extrafieldData) {
                if (childParent[i] && childParent[i].length) {
                    for (let j = 0; j < childParent[i].length; j++) {
                        if (childParent[i][j].field === "extraField") {
                            extrafieldData[childParent[i][j].id] = efRM[childParent[i][j].id];
                        }
                    }
                }
            }
            if (Object.keys(exp_value).length === 0) {
                extrafieldData = this.extrafieldRunningMap["txn_expression"];
            }
            this._setExtraFieldRunningMapValues(extrafieldData, "txn_expression");
            this.emit("change", "expression");
        } else {
            this.expressionExtraFieldObject = expObj;
        }
    }
    _getExpressionExtraField(type) {
        return this.expressionExtraFieldObject[type] || [];
    }
    _setExtraFieldMetaStructure(resource_name) {
        let extrafield = this._getextraFields(resource_name) || [];
        let extraFieldMetaStructure = extrafield;
        let extrafieldMap = {};
        for (let i in extrafield) {
            extrafieldMap[extrafield[i].field_id] = extrafield[i].field_value;
        }
        let efResources = this.efResources;
        efResources[resource_name] = {
            extraFieldMetaStructure,
            extrafieldMap
        };
        this.efResources = efResources;
        this.emit("change", "efMetaStructure");
    }
    _getExtraFieldMetaStructure(type) {
        return this.efResources[type];
    }
    _getExtraFieldRunningMap(resource_name) {
        return this.extrafieldRunningMap[resource_name] || {};
    }
    _setExtraFieldRunningMapValues(ef, con_type, page, isExpressionType, overrideRunningMap) {
        if (!this.extrafieldRunningMap[con_type] || overrideRunningMap) {
            this.extrafieldRunningMap[con_type] = {};
        }

        if (!this.extraFieldMap[con_type]) {
            this.extraFieldMap[con_type] = {};
        }

        this.extraFieldMap[con_type] = { ...this.extraFieldMap[con_type], ...ef };
        this.extrafieldRunningMap[con_type] = { ...this.extrafieldRunningMap[con_type], ...ef };
        // this.extrafieldRunningMap[con_type] = Object.assign({}, this.extraFieldMap[con_type]);
        if (page === "split") {
            this.extrafieldRunningMap["split-1"] = Common._perfectClone(
                this.extrafieldRunningMap[con_type]
            );
            // Initiallly their will be two split, so copying all initial values.
            this.initialExtrafieldValues = Common._perfectClone(
                this.extrafieldRunningMap[con_type]
            );
            // Storing initial values, since initials values are needed at time of SPLIT MORE.
        }
        // The below logic is to update ef stored in txn_expression type and are transaction expression dependendent
        if (isExpressionType) {
            for (let i in ef) {
                const efRMap = this.extrafieldRunningMap["txn_expression"] || {};
                if (i in efRMap && ef[i]) {
                    efRMap[i] = ef[i];
                }
                const efMap = this.extraFieldMap["txn_expression"] || {};
                if (i in efMap && ef[i]) {
                    efMap[i] = ef[i];
                }
            }
        }
        const evalEFArr = [];
        const ocrParsedData = ExpenseStores._getParsedData();
        for (let i in ef) {
            if (i in this.concatMappedFields && !evalEFArr.includes(this.concatMappedFields[i])) {
                evalEFArr.push(this.concatMappedFields[i]);
            }
        }
        if (ocrParsedData?.transaction?.currency_amount) {
            for (let i in this.concatMappedFields) {
                if (i.includes("amount-") && !evalEFArr.includes(this.concatMappedFields[i]))
                    evalEFArr.push(this.concatMappedFields[i]);
            }
        }
        for (let i = 0; i < evalEFArr.length; i++) {
            if (
                !this.extrafieldRunningMap[con_type][evalEFArr[i]] &&
                this.reverseMap?.[con_type]?.[evalEFArr[i]]
            ) {
                this._setCompositeOrExpValue(this.reverseMap[con_type][evalEFArr[i]], con_type, {
                    [evalEFArr[i]]: ""
                });
            }
        }

        this.emit(
            "change",
            "ef_data",
            this.extrafieldRunningMap[con_type],
            "",
            "",
            con_type === "txn_expression" ? "eval_exp" : ""
        );
    }

    _processOCRData(ef, reRun) {
        /*
            1. Only applicable to text type EF - name_type == "text".
            2. If a text field has a default value then it won't be over written - !default_selected.
            3. If any field has been entered by the user/or via API before invoice upload then it won't be overwritten - !this.extrafieldRunningMap["transaction"][ef_id].
            4. Any field which is a calculated type field will not be filled - !is_expression.
            5. If the user has read only/deny/hidden permission for that field at that state then it wont be filled - !is_invisible && ef_id in this.reverseMap["transaction"]
            6. For container type - !this.containerMappedFields.includes(ef_id), for link type - !(field_type == "text_area" && is_hidden).
            7. should be filled only if the user has read/write permission - !is_hidden.

              this.ocrFilledFields - Will store all the fields which will be considered for auto-filling on image upload.
        */
        // If ef is not coming then ignore processing.
        if (Object.keys(ef||{}).length < 1)
            return false;
        const obj = {};
        for (let i in ef) {
            const field = this.reverseMap["transaction"]?.[i];
            if (!field) continue;
            const {
                name_type,
                default_selected,
                is_expression,
                is_invisible,
                field_type,
                is_hidden,
                field_id
            } = field;
            if (!["number", "text"].includes(name_type)) continue;
            if (name_type === "number" && isNaN(Number(ef[i]))) continue;
            if (default_selected) continue;
            if (this.extrafieldRunningMap["transaction"][field_id]) continue;
            if (is_expression && Object.keys(is_expression).length > 0 && field_type !== "gstin")
                continue;
            if (is_invisible) continue;
            if (is_hidden) continue;
            if (this.containerMappedFields.includes(`${field_id}`)) continue;
            if (field_type === "text_area" && is_hidden) continue;
            if (reRun && !document.getElementById(`field-${field_id}`)) continue;
            obj[i] = ef[i];
            this.ocrFilledFields.push(i);
        }        
        if (Object.keys(obj).length > 0) {
            this._setExtraFieldRunningMapValues(obj, "transaction");
        }
    }

    _setCityDependentExtrafieldValue(type, resource, value) {
        if (this.extraFieldNative[type] && Array.isArray(this.extraFieldNative[type])) {
            this.extraFieldNative[type].forEach(nativeEf => {
                let ef = this.reverseMap[resource][nativeEf];

                if (ef.is_invisible && value) {
                    let val = {};
                    if (ef.name_type === "text") {
                        val = JSON.parse(ef.values);
                    }
                    if (val[value]) {
                        this.extrafieldRunningMap[resource][nativeEf] = val[value];
                    } else {
                        this.extrafieldRunningMap[resource][nativeEf] = "";
                    }
                } else if (
                    ef.is_dependent_on &&
                    ef.is_dependent_on.field_key &&
                    !ef.is_dependent_on.field_key.includes(value)
                ) {
                    this.extrafieldRunningMap[resource][nativeEf] = "";
                    if (Array.isArray(ef.guardian)) {
                        ef.guardian.forEach(el => {
                            if (this.extrafieldRunningMap[resource][el]) {
                                this.extrafieldRunningMap[resource][el] = "";
                            }
                        });
                    }
                }
            });
        }
    }

    _flushExtraFieldRunningMapValues(con_type) {
        this.extrafieldRunningMap[con_type] = {};
    }
    _flushExtrafieldMap(con_type) {
        this.extrafieldRunningMap[con_type] = {};
        this.extraFieldMap[con_type] = {};
    }
    _emptyGuardians({ guardian }, efRM) {
        if (guardian && guardian.length > 0) {
            guardian.map(el => (efRM[+el] = ""));
        }
    }

    _isDepOntxn({ is_dependent_on }, onlyTxnTypeDependent) {
        let is_dep = is_dependent_on;

        if (
            is_dep &&
            is_dep.field == "txn_type" &&
            is_dep.field_key &&
            (!is_dep.field_key.includes(`${onlyTxnTypeDependent}`) || this.mode === "create")
        ) {
            return true;
        }
        return false;
    }

    _isDepOntxnWithDefault({ is_dependent_on, default_selected_value, field_id }, con_type) {
        let is_dep = is_dependent_on;

        if (
            is_dep &&
            is_dep.field == "txn_type" &&
            default_selected_value &&
            !this.extrafieldRunningMap[con_type][field_id]
        ) {
            return true;
        }
        return false;
    }

    _emptyExtrafieldDependentEf(ef, con_type, efRM) {
        const { is_dependent_on, guardian } = ef;
        if (is_dependent_on && is_dependent_on.id && !efRM[is_dependent_on.id]) {
            this._emptyValueOfGuardian(ef, guardian, con_type, efRM);
        }
    }

    _initExtraFieldRunningMapValues(con_type, onlyTxnTypeDependent, efFetched) {
        let ef = this._getextraFields(con_type);
        let efRM = this._getExtraFieldRunningMap(con_type);
        let txnRM = this._getExtraFieldRunningMap("txn_expression");
        this.current_txn_type = onlyTxnTypeDependent || "";
        for (let i = 0; i < ef.length; i++) {
            if (!onlyTxnTypeDependent) {
                if (this.extraFieldNative["txn_type"].includes(ef[i].field_id)) {
                    efRM[ef[i].field_id] = "";
                    this._emptyGuardians(ef[i], efRM);
                }
            } else if (this._isDepOntxn(ef[i], onlyTxnTypeDependent)) {
                efRM[ef[i].field_id] = "";

                this._emptyGuardians(ef[i], efRM);

                if (txnRM[ef[i].field_id]) {
                    txnRM[ef[i].field_id] = "";
                }
            }
            if (this._isDepOntxnWithDefault(ef[i], con_type)) {
                if (
                    Array.isArray(ef[i].is_dependent_on.field_key) &&
                    !ef[i].is_dependent_on.field_key.includes(`${onlyTxnTypeDependent}`)
                ) {
                    continue; // Selected transaction is not included in particular keys of extrafield which are dependent of transaction
                }
                if (["text", "number", "BACC", "IFSC"].includes(ef[i].name_type)) {
                    efRM[ef[i].field_id] = ef[i].default_selected_value;
                } else {
                    let defaultSelected = JSON.parse(ef[i].default_selected_value);
                    if (this.mode !== "edit")
                        this._setExtraFieldDDRunningMap(
                            defaultSelected[onlyTxnTypeDependent] || "",
                            ef[i].field_id,
                            con_type
                        );
                    efRM[ef[i].field_id] = defaultSelected[onlyTxnTypeDependent] || "";
                }
            }

            this._emptyExtrafieldDependentEf(ef[i], con_type, efRM);

            if (
                this.efMapforExpressionOrComposite[con_type] &&
                Object.keys(this.efMapforExpressionOrComposite[con_type]).includes(
                    `${ef[i].field_id}`
                )
            ) {
                if (!this.extrafieldRunningMap[con_type][ef[i].field_id]) {
                    this.efMapforExpressionOrComposite[con_type][ef[i].field_id].forEach(el => {
                        const { is_dependent_on } = this.reverseMap[con_type][el] || {};
                        if (
                            !(
                                is_dependent_on &&
                                Array.isArray(is_dependent_on.field_key) &&
                                is_dependent_on.field_key.includes(
                                    this.extrafieldRunningMap[con_type][is_dependent_on.id]
                                )
                            )
                        ) {
                            var ef = this.reverseMap[con_type][el];

                            if (
                                this.extrafieldRunningMap[con_type][el] &&
                                ef &&
                                ef.field_type === "composite"
                            ) {
                                let val = "";
                                ef.is_expression &&
                                    ef.is_expression.composite
                                        .slice(2, -2)
                                        .split(",")
                                        .forEach(ele => {
                                            let compExpval = this.extrafieldRunningMap[con_type][
                                                ef.is_expression[ele]
                                            ];
                                            if (compExpval) {
                                                val += compExpval;
                                            }
                                        });
                                if (efFetched && val !== this.extrafieldRunningMap[con_type][el]) {
                                    this.extrafieldRunningMap[con_type][el] = "";
                                }
                            } else {
                                this.extrafieldRunningMap[con_type][el] = efFetched
                                    ? this.extrafieldRunningMap[con_type][el] || ""
                                    : "";
                            }
                        }
                    });
                }
            }
        }
        this.extrafieldRunningMap[con_type] = efRM;
        this.extrafieldRunningMap["txn_expression"] = txnRM;
        // this.emit("change", "extrafieldDDRunningMap");
    }

    _initExtraFieldRunningMapValuesOther(con_type) {
        let efRM = this._getExtraFieldRunningMap(con_type);
        let ef_spec = this._getExtraFieldNative();

        let tempObj = Object.assign({}, efRM);
        Object.keys(tempObj).map(objectKey => {
            if (ef_spec && ef_spec.category && ef_spec.category.length) {
                ef_spec.category.forEach(el => {
                    el = `${el}`;
                    if (el == objectKey) {
                        efRM[objectKey] = "";
                    }
                });
            }
        });
    }
    saveContentType(obj) {
        this.contentTypeMap = Object.assign({}, obj, this.contentTypeMap);
    }

    getContentType(fieldId) {
        return this.contentTypeMap[fieldId];
    }
    _getEFRunningMapValue(con_type, id) {
        return (
            (this.extrafieldRunningMap &&
                this.extrafieldRunningMap[con_type] &&
                this.extrafieldRunningMap[con_type][id]) ||
            ""
        );
    }
    _setExtraFieldFileDelete(fId, fileIndex, con_type) {
        if (this.extrafieldRunningMap[con_type][fId])
            this.extrafieldRunningMap[con_type][fId].push(fileIndex);
        else {
            this.extrafieldRunningMap[con_type][fId] = [];
            this.extrafieldRunningMap[con_type][fId].push(fileIndex);
        }
    }

    _setExtraFieldRunningMapValuesWithOutEmit(val, fid, con_type) {
        this.setRunningMap(con_type, fid, val);
    }

    _setExtraFieldRunningMap(val, fid, con_type, extraParam) {
        if (extraParam === "bacc") {
            if (!this.extrafieldRunningMap[con_type][`${fid}-BACC`]) {
                this.extrafieldRunningMap[con_type][`${fid}-BACC`] = "";
            }
        }

        this.setRunningMap(con_type, fid, val);

        // The below check is for those text field which are used in expression of other EF
        const isExpDep =
            this.extraFields[con_type] &&
            this.extraFields[con_type].find(ef =>
                Object.values(ef.is_expression || {}).includes(`${fid}`)
            );
        if (isExpDep) {
            // HEPIT-4040: The below check added for calling for the expresion field if value not there
            if (!this.extrafieldRunningMap[con_type][isExpDep.field_id]) {
                this._setCompositeOrExpValue(isExpDep, con_type, { [isExpDep.field_id]: "" });
            } else if (isExpDep.field_type === "date_diff"
                || this.reverseMap?.[con_type]?.[fid]?.field_type === "financial_year"
                || this.reverseMap?.[con_type]?.[fid]?.name_type === "date") {
                // This check is to handle the date change trigger
                this._setCompositeOrExpValue(isExpDep, con_type, { [isExpDep.field_id]: "" });
            }
        }

        try {
            if (con_type === "transaction" && fid in this.extrafieldRunningMap["txn_expression"]) {
                this.extrafieldRunningMap["txn_expression"][fid] = val;
            }
        } catch (e) {
            // donot do anything
        }

        let isEvaluate = "";

        if (
            (Object.keys(this.extrafieldRunningMap.txn_expression || {}).includes(String(fid)) &&
                this.extrafieldRunningMap.txn_expression[fid]) ||
            con_type == "txn_expression"
        ) {
            isEvaluate = "eval_exp";
        }

        this.emit("change", "extrafieldRunningMap", fid, val, extraParam, isEvaluate);
    }
    setRunningMap(con_type, fid, val) {
        if (!this.extrafieldRunningMap[con_type]) {
            this.extrafieldRunningMap[con_type] = {};
        }
        if (!this.extraFieldMap[con_type]) {
            this.extraFieldMap[con_type] = {};
        }
        if (con_type === "transaction" && this.ocrFilledFields.includes(`${fid}`)) {
            this.ocrFilledFields = this.ocrFilledFields.filter(id => id !== `${fid}`);
        }
       
        this.extrafieldRunningMap[con_type][fid] = val;
        this.extraFieldMap[con_type][fid] = val;

        if (fid.toString()?.includes("From") && this.extrafieldRunningMap[con_type][fid]?.length <= 0) {
            const [id, text] = fid.split("-");
            this.extrafieldRunningMap[con_type][`${id}-To`] = null;
            this.extraFieldMap[con_type][`${id}-To`] = null;
        }
    }
    isOCRFilledField(fid, con_type) {
        if (con_type === "transaction" && this.ocrFilledFields.includes(`${fid}`)) {
            return true;
        } 
            return false;
        
    }
    _clearOCRFilledFields() {
        this.ocrFilledFields.forEach(id => {
            this.extrafieldRunningMap["transaction"][id] = "";
            if (id in this.concatMappedFields) {
                this.extrafieldRunningMap["transaction"][this.concatMappedFields[id]] = "";
            }
        });
        this.ocrFilledFields = [];
    }

    _overrideTxnExpFields(id, val) {
        //This function returns true if there is any override in the txn expression field.
        if (
            this.extrafieldRunningMap["txn_expression"] &&
            this.extrafieldRunningMap["txn_expression"].hasOwnProperty(id)
        ) {
            this.extrafieldRunningMap["txn_expression"][id] = val === undefined ? "0" : val;
            return true;
        }
        return false;
    }

    _isDepOnCatWithDefult(ef) {
        const { default_selected_value, is_dependent_on } = ef;
        if (default_selected_value && is_dependent_on && is_dependent_on.field == "category") {
            return true;
        }
        return false;
    }

    _isDepOnCat({ is_dependent_on }) {
        let is_dep = is_dependent_on;

        if (is_dep && is_dep.field == "category") {
            return true;
        }
        return false;
    }

    // con_type is having default value as transcation because category is a property of transaction
    categoryDependentDDRunningMap(catid, con_type = "transaction") {
        let ids = this.extraFieldNative["category"] || [];
        let efRM = this._getExtraFieldRunningMap(con_type);

        for (const id of ids) {
            let ef = this.reverseMap["transaction"][id];

            if (!ef) continue;

            if (this._isDepOnCat(ef)) {
                if (catid &&
                    Array.isArray(ef?.is_dependent_on?.field_key) &&
                    !ef?.is_dependent_on?.field_key.includes(`${catid}`)) {
                    this.initializeExtrafieldRunningMap(id);
                } else if (!catid) {
                    this.initializeExtrafieldRunningMap(id);
                }
                // when category is selected after the con_type then we are reinitialize the extrafileds: here we map fields we already have values. 
                // HEPIT-12750
                const selectedRow = GenericContainerTypeStore._getMapForSelectedRow(con_type);
                if (selectedRow && selectedRow?.[id]) {
                    this.extrafieldRunningMap["transaction"][id] = selectedRow?.[id]
                }

                if (this._isDepOnCatWithDefult(ef)) {
                    if (
                        catid &&
                        Array.isArray(ef.is_dependent_on.field_key) &&
                        !ef.is_dependent_on.field_key.includes(`${catid}`)
                    ) {
                        continue; // Selected Category is not included in particular keys of extrafield which are dependent of category
                    }
                    
                    if (["text", "number", "BACC", "IFSC"].includes(ef.name_type)) {
                        this.extrafieldRunningMap["transaction"][ef.field_id] =
                            ef.default_selected_value;
                    } else {
                        let defaultSelected = "";
                        try {
                             defaultSelected = JSON.parse(ef.default_selected_value);
                        } catch(e){
                            defaultSelected = ef.default_selected_value;
                        }
                        // let defaultSelected = Array.isArray(ef.default_selected_value) ? JSON.parse(ef.default_selected_value) : ef.default_selected_value;
                        this._setExtraFieldDDRunningMap(
                            defaultSelected[catid] || "",
                            ef.field_id,
                            con_type
                        );
                    }
                }
                // HEPIT-11051: This is not required here as it is already handled in textfieldComp.js
                // else {
                //     // This is for when category is changed but dependent extrafield is not getting changed if extrafiled does not have any default values: HTPIT-1979
                //         let val = "";
                //         try {
                //             val = JSON.parse(ef.values) || [];
                //         } catch(e){
                //             val = ef.values;
                //         }
                //         let categoryValues = val[catid];
                //         if(val[catid]) {
                //             if(Array.isArray(val[catid])) {
                //                 categoryValues = val[catid]
                //             } else if (isObject(val[catid])) {
                //                 categoryValues = Object.keys(val[catid]);
                //             }
                //         }
                //         this._setExtraFieldDDRunningMap(
                //             categoryValues,
                //             ef.field_id,
                //             con_type
                //         );
                // }
            }

            if (
                this.efMapforExpressionOrComposite[con_type] &&
                Object.keys(this.efMapforExpressionOrComposite[con_type]).includes(`${ef.field_id}`)
            ) {
                if (
                    this.extrafieldRunningMap[con_type][ef.field_id] == "" ||
                    !this.extrafieldRunningMap[con_type][ef.field_id]
                ) {
                    this.efMapforExpressionOrComposite[con_type][ef.field_id].forEach(el => {
                        this.extrafieldRunningMap[con_type][el] = "";
                    });
                }
            }

            this._emptyExtrafieldDependentEf(ef, con_type, efRM);
        }
    }

    initializeExtrafieldRunningMap(id) {
        if (this.extrafieldRunningMap["transaction"][id]) {
            this.extrafieldRunningMap["transaction"][id] = "";
        }
    }

    emptyGuardianArray(array = [], con_type) {
        Array.isArray(array) &&
            array.forEach(el => {
                if (this.extrafieldRunningMap[con_type]) {
                    this.extrafieldRunningMap[con_type][el] = "";
                }
            });
    }

    _setExtraFieldDDRunningMap(val, fid, con_type) {
        val = val === null ? "" : val;
        let newItem = {};
        let extraFieldStatic = this._getextraFields(con_type);
        if (con_type && !(con_type in this.extrafieldRunningMap)) {
            this.extrafieldRunningMap[con_type] = {};
        }
        this.extrafieldRunningMap[con_type][fid] = val;
        newItem[fid] = val;
        let guardians =
            this.reverseMap[con_type] &&
            this.reverseMap[con_type][fid] &&
            this.reverseMap[con_type][fid].guardian;
        if (guardians) {
            this._resetNestedFields(
                fid,
                guardians,
                this.reverseMap[con_type],
                newItem,
                val,
                con_type
            );
        }

        for (let el of extraFieldStatic) {
            if (
                el.is_dependent_on &&
                (el.is_dependent_on.field == "extrafield" ||
                    el.is_dependent_on.field == "extraField")
            ) {
                if (
                    el.is_dependent_on &&
                    el.is_dependent_on.id == fid &&
                    ["number", "text", "BACC", "IFSC", "date"].includes(el.name_type)
                ) {
                    let allValues = el.values;
                    if (el.default_selected_value) {
                        if (
                            this.extrafieldRunningMap[con_type][el.is_dependent_on.id] &&
                            !el.is_dependent_on.field_key.includes(
                                this.extrafieldRunningMap[con_type][el.is_dependent_on.id]
                            )
                        ) {
                            this.extrafieldRunningMap[con_type][el.field_id] = "";
                        } else {
                            this.extrafieldRunningMap[con_type][el.field_id] =
                                el.default_selected_value;
                        }
                    }
                    if (allValues && allValues !== "{}") {
                        let vals = JSON.parse(el.values);
                        let value =
                            vals[this.extrafieldRunningMap[con_type][el.is_dependent_on.id]];
                        value = value === 0 ? `${value}` : value;
                        if (["text", "date"].includes(el.name_type) && !value) value = "";

                        this.extrafieldRunningMap[con_type][el.field_id] = value;
                        if (con_type === "transaction") {
                            let isChanged = this._overrideTxnExpFields(el.field_id, value);
                            if (isChanged) {
                                newItem[el.field_id] = value === undefined ? "0" : value;
                            }
                        }
                    }
                    // else if(isEf && allValues && el.is_hidden==false){
                    // 	this.extrafieldRunningMap[con_type][el.field_id] = '';
                    // }
                } else if (
                    el.is_dependent_on &&
                    el.is_dependent_on.id == fid &&
                    el.name_type === "dropdown"
                ) {
                    let vals = el.values;
                    let value =
                        vals[this.extrafieldRunningMap[con_type][el.is_dependent_on.id]] || {};

                    try {
                        if (el.default_selected_value) {
                            if (
                                el.is_dependent_on &&
                                el.is_dependent_on.field_key &&
                                !el.is_dependent_on.field_key.includes(
                                    this.extrafieldRunningMap[con_type][el.is_dependent_on.id]
                                )
                            ) {
                                this.extrafieldRunningMap[con_type][el.field_id] = "";
                                newItem[el.field_id] = "";
                            } else {
                                this.extrafieldRunningMap[con_type][el.field_id] = JSON.parse(
                                    el.default_selected_value
                                )[this.extrafieldRunningMap[con_type][el.is_dependent_on.id]];
                                newItem[el.field_id] = this.extrafieldRunningMap[con_type][
                                    el.field_id
                                ];
                            }
                        }
                    } catch (error) {
                        console.error(error);
                    }

                    if (!value) {
                        this.extrafieldRunningMap[con_type][el.field_id] = "";
                        newItem[el.field_id] = "";
                        this.emptyGuardianArray(el.guardian, con_type);
                    }
                    if (
                        !Object.keys(value).includes(
                            this.extrafieldRunningMap[con_type][el.field_id]
                        )
                    ) {
                        this.extrafieldRunningMap[con_type][el.field_id] = "";
                        newItem[el.field_id] = "";
                        this.emptyGuardianArray(el.guardian, con_type);
                    }
                } else if (
                    el.is_dependent_on &&
                    el.is_dependent_on.id == fid &&
                    el.name_type == "multi_select_dropdown"
                ) {
                    let vals = el.values;
                    let keys = this.extrafieldRunningMap[con_type][el.is_dependent_on.id] || [];
                    for (let j = 0; j < keys.length; j++) {
                        if (vals[keys[j]]) {
                            let checkVal = vals[keys[j]];
                            if (
                                !Object.keys(checkVal).includes(
                                    this.extrafieldRunningMap[con_type][el.field_id]
                                )
                            ) {
                                this.extrafieldRunningMap[con_type][el.field_id] = "";
                                newItem[el.field_id] = "";
                                this.emptyGuardianArray(el.guardian, con_type);
                            }
                        } else {
                            this.extrafieldRunningMap[con_type][el.field_id] = "";
                            newItem[el.field_id] = "";
                            this.emptyGuardianArray(el.guardian, con_type);
                        }
                    }
                }
                if (
                    el.field_id !== fid &&
                    ["composite", "expression"].includes(el.field_type) &&
                    Object.keys(el.is_expression).length > 0
                ) {
                    this._setCompositeOrExpValue(el, con_type, newItem);
                }
            } else if (
                el.field_id !== fid &&
                ["composite", "expression"].includes(el.field_type) &&
                Object.keys(el.is_expression).length > 0
            ) {
                this._setCompositeOrExpValue(el, con_type, newItem);
            } else {
                //Native fields
                if (el.field_id == fid) {
                    let isChanged = this._overrideTxnExpFields(el.field_id, val);
                    if (isChanged) {
                        newItem[el.field_id] = val;
                    }
                }
            }
        }

        /* 	expDepTxnField variable is used because in some cases the field used in txn expression is auto 
				poulated with the selection of some dependent extrafield.So here when con_type is transaction we check for 
				the new parameter and decide whether eval function will be called or not.
		*/
        let efRMTE = this.extrafieldRunningMap["txn_expression"] || {};
        let expDepTxnField = false;
        if (Object.keys(efRMTE).length) {
            expDepTxnField = true;
            if (con_type === "transaction") {
                for (let i in newItem) {
                    if (efRMTE.hasOwnProperty(i))
                        this.extrafieldRunningMap["txn_expression"][i] = newItem[i];
                }
            }
        }
        this.extraFieldMap[con_type] = Object.assign({}, this.extrafieldRunningMap[con_type]);
        let ocrData = ExpenseStores._getParsedData();
        const { location: { query: { draft_id = "" } } } = history;
        if (draft_id) {
            const temp = ExpenseStores._getDraftUpdateData()?.extra_field?.extra_fields?.[draft_id];     
            ocrData = {extra_field: this._commonObjCreation({}, temp)};
        }

        const ocrObj = {};
        for (let i in ocrData?.extra_field) {
            if (ocrData.extra_field[i] !== null && ocrData.extra_field[i] !== "") {
                ocrObj[i] = ocrData.extra_field[i];
            }
        }

        this.emit(
            "change",
            "ef_data",
            this.extrafieldRunningMap[con_type],
            "",
            "",
            con_type === "txn_expression" ? "eval_exp" : expDepTxnField ? "eval_exp" : ""
        );
        setTimeout(() => {
            this._processOCRData(ocrObj, true);
        }, 0);
    }

    _emptyValueOfGuardian(
        { default_selected_value, field_id },
        guardianArr,
        con_type,
        newItem,
        from
    ) {
        if (default_selected_value !== null || from == "composite") {
            if (newItem) {
                newItem[field_id] = "";
            }

            this.extrafieldRunningMap[con_type][field_id] = "";
            Array.isArray(guardianArr) &&
                guardianArr.forEach(el => {
                    if (el) {
                        this.extrafieldRunningMap[con_type][el] = "";
                        if (newItem) {
                            newItem[el] = "";
                        }
                    }
                });
        }
    }

    _setDefaultValueOnSelection(
        $val,
        guardianExf,
        guardianId,
        EFObject,
        newItem,
        con_type,
        parsedDefaultSelectedValue
    ) {
        if (
            !newItem[guardianExf.is_dependent_on.id] ||
            (guardianExf.is_dependent_on.field_key &&
                !guardianExf.is_dependent_on.field_key.includes(
                    newItem[guardianExf.is_dependent_on.id]
                ))
        ) {
            this._emptyValueOfGuardian(guardianExf, guardianExf.guardian, con_type, newItem);
        } else {
            newItem[guardianId] =
                parsedDefaultSelectedValue[newItem[guardianExf.is_dependent_on.id]];
            this.extrafieldRunningMap[con_type][guardianId] =
                parsedDefaultSelectedValue[newItem[guardianExf.is_dependent_on.id]];
            let guardians = guardianExf.guardian;
            if (guardians && Array.isArray(guardians) && guardians.length > 0) {
                this._resetNestedFields(
                    guardianId,
                    guardians,
                    EFObject,
                    newItem,
                    parsedDefaultSelectedValue[$val],
                    con_type
                );
            }
        }
    }

    _resetNestedFields(fid, guardianArr, EFObject, newItem, val, con_type) {
        for (let guardianId of guardianArr) {
            let guardianExf = EFObject[guardianId];

            if (!guardianExf || !guardianId) continue;

            let values = isJson(guardianExf.values)
                ? guardianExf.values
                : JSON.parse(guardianExf.values);

            let $val = "";

            if (!val && !newItem[fid])
                this._emptyValueOfGuardian(guardianExf, guardianExf.guardian, con_type, newItem);
            else $val = newItem[fid];

            if (
                guardianExf.name_type != "dropdown" &&
                guardianExf.name_type != "multi_select_dropdown" &&
                values &&
                newItem[guardianId] &&
                newItem[guardianId] == values[val]
            ) {
                console.log("dont change");
            } else if (
                guardianExf.name_type == "dropdown" ||
                guardianExf.name_type == "multi_select_dropdown"
            ) {
                let parsedDefaultSelectedValue =
                    JSON.parse(guardianExf.default_selected_value) || "";
                if (
                    guardianExf.is_dependent_on &&
                    guardianExf.is_dependent_on.field.toLowerCase() == "extrafield"
                ) {
                    // if($val && parsedDefaultSelectedValue && EFObject[guardianId].name_type=='dropdown' && Object.keys(parsedDefaultSelectedValue).includes($val)){
                    if ($val && parsedDefaultSelectedValue && guardianExf.name_type == "dropdown") {
                        this._setDefaultValueOnSelection(
                            $val,
                            guardianExf,
                            guardianId,
                            EFObject,
                            newItem,
                            con_type,
                            parsedDefaultSelectedValue
                        );
                    } else if (
                        $val &&
                        parsedDefaultSelectedValue &&
                        guardianExf.name_type == "multi_select_dropdown"
                    ) {
                        if (EFObject[guardianExf.is_dependent_on.id].name_type === "dropdown") {
                            this._setDefaultValueOnSelection(
                                $val,
                                guardianExf,
                                guardianId,
                                EFObject,
                                newItem,
                                con_type,
                                parsedDefaultSelectedValue
                            );
                        } else if (Array.isArray($val) && guardianExf.is_dependent_on.id == fid) {
                            let Arr = [];
                            $val.forEach(el => {
                                if (Object.keys(parsedDefaultSelectedValue).includes(el)) {
                                    let defVal = [];
                                    parsedDefaultSelectedValue[el].forEach(ele => {
                                        defVal.push(ele);
                                    });
                                    Arr = Arr.concat(defVal);
                                }
                            });
                            newItem[guardianExf.field_id] = Arr;
                            this.extrafieldRunningMap[con_type][guardianExf.field_id] = Arr;
                            let guardians = guardianExf.guardian;
                            if (guardians && Array.isArray(guardians) && guardians.length > 0)
                                this._resetNestedFields(
                                    guardianId,
                                    guardians,
                                    EFObject,
                                    newItem,
                                    parsedDefaultSelectedValue[$val],
                                    con_type
                                );
                        } else if (newItem[guardianExf.is_dependent_on.id] == "")
                            this._emptyValueOfGuardian(
                                guardianExf,
                                guardianExf.guardian,
                                con_type,
                                newItem
                            );
                    }
                } else
                    this._emptyValueOfGuardian(
                        guardianExf,
                        guardianExf.guardian,
                        con_type,
                        newItem
                    );
            } else if (
                guardianExf.is_dependent_on &&
                newItem &&
                newItem[guardianExf.is_dependent_on.id] &&
                ["number", "text", "IFSC", "BACC"].includes(guardianExf.name_type) &&
                guardianExf.is_dependent_on.field.toLowerCase() == "extrafield" &&
                newItem[guardianExf.is_dependent_on.id] !== ""
            ) {
                if (
                    !Object.keys(newItem).includes(`${guardianExf.is_dependent_on.id}`) ||
                    (Array.isArray(guardianExf.is_dependent_on.field_key) &&
                        !guardianExf.is_dependent_on.field_key.includes(
                            newItem[guardianExf.is_dependent_on.id]
                        ))
                ) {
                    this.extrafieldRunningMap[con_type][guardianExf.field_id] = "";
                    // this._emptyValueOfGuardian(guardianExf, guardianExf.guardian, con_type, newItem)
                } else {
                    let val =
                        typeof guardianExf.values === "string"
                            ? JSON.parse(guardianExf.values)
                            : guardianExf.values;

                    if (guardianExf.default_selected_value && Object.keys(val).length < 1) {
                        newItem[guardianExf.field_id] = guardianExf.default_selected_value;
                        this.extrafieldRunningMap[con_type][guardianExf.field_id] =
                            guardianExf.default_selected_value;
                    } else {
                        if(val && Object.keys(val).length > 0) {
                            let val1 = val && newItem && guardianExf?.is_dependent_on?.id && val[newItem[guardianExf?.is_dependent_on?.id]];

                            newItem[guardianExf.field_id] = val1 === 0 ? "0" : val1 || "";
                            
                            this.extrafieldRunningMap[con_type][guardianExf.field_id] =
                                val1 === 0 ? "0" : val1 || "";
                        }
                    }
                }
                let guardians = guardianExf.guardian;
                if (guardians && Array.isArray(guardians) && guardians.length > 0)
                    this._resetNestedFields(
                        guardianId,
                        guardians,
                        EFObject,
                        newItem,
                        newItem[$val],
                        con_type
                    );
            } else if (
                guardianExf.name_type === "con_type" &&
                guardianExf.is_dependent_on &&
                guardianExf.is_dependent_on.field.toLowerCase() == "extrafield"
            ) {
                if (
                    this.extrafieldRunningMap[con_type][guardianExf.is_dependent_on.id] === "" ||
                    !this.extrafieldRunningMap[con_type][guardianExf.is_dependent_on.id] ||
                    !guardianExf.is_dependent_on.field_key.includes(
                        this.extrafieldRunningMap[con_type][guardianExf.is_dependent_on.id]
                    )
                ) {
                    this.extrafieldRunningMap[con_type][guardianExf.field_id] = "";
                    GenericContainerTypeStore._removeContainerEFInfo(
                        guardianExf.field_id,
                        con_type
                    );
                    if (
                        guardianExf.additional_map &&
                        typeof guardianExf.additional_map === "object" &&
                        Object.keys(guardianExf.additional_map).length > 0
                    ) {
                        Object.keys(guardianExf.additional_map).forEach(ef => {
                            this.extrafieldRunningMap[con_type][ef] = "";
                        });
                    }
                }
            } else {
                this._emptyValueOfGuardian(guardianExf, guardianExf.guardian, con_type, newItem);
            }
            // if (
            //     this.efMapforExpressionOrComposite[con_type] &&
            //     Object.keys(this.efMapforExpressionOrComposite[con_type]).includes(
            //         `${guardianExf.field_id}`
            //     )
            // ) {
            //     if (
            //         this.extrafieldRunningMap[con_type][guardianExf.field_id] == "" ||
            //         !this.extrafieldRunningMap[con_type][guardianExf.field_id]
            //     ) {
            //         this.efMapforExpressionOrComposite[con_type][guardianExf.field_id].forEach(
            //             el => {
            //                 this.extrafieldRunningMap[con_type][el] = "";
            //             }
            //         );
            //     }
            // }
        }
    }

    _commonObjCreation(targetObj, efObj) {
        for (let i in efObj) {
            let temp = efObj[i];
            if (temp.name_type == "date_range") {
                let fromId = `${temp.field_id}-From`;
                let toId = `${temp.field_id}-To`;
                try {
                    let val = JSON.parse(temp.field_value);
                    if (val.from && val.from != "Invalid Date")
                        targetObj[fromId] = new Date(
                            Common._formatDate(val.from, "YYYY/MM/DD HH:mm:ss")
                        );
                    if (val.to && val.to != "Invalid Date")
                        targetObj[toId] = new Date(
                            Common._formatDate(val.to, "YYYY/MM/DD HH:mm:ss")
                        );
                } catch (e) {
                    //invalid value saved in daterange format
                }
            } else if (temp.name_type == "BACC") {
                let confirmId = `${temp.field_id}-BACC`;
                targetObj[temp.field_id] = temp.field_value;
                targetObj[confirmId] = temp.field_value;
            } else if (temp.name_type == "file") {
                let oldFiles = `${temp.field_id}-OldFiles`;
                targetObj[oldFiles] = temp.field_value;
            } else if (temp.name_type === "date" || temp.name_type === "last_working_day") {
                targetObj[temp.field_id] = new Date(
                    Common._formatDate(temp.field_value, "YYYY/MM/DD HH:mm:ss")
                );
            } else if (temp.name_type == "prefix") {
                targetObj[temp.field_id] =
                    temp.field_value && temp.field_value !== ""
                        ? temp.field_value.substring(temp.prefix.length, temp.length)
                        : "";
            } else if (temp.name_type == "postfix") {
                targetObj[temp.field_id] =
                    temp.field_value && temp.field_value !== ""
                        ? temp.field_value.substring(0, temp.field_value.indexOf(temp.postfix))
                        : "";
            } else if (temp.name_type === "time") {
                targetObj[temp.field_id] = new Date(`2017-01-01 ${temp.field_value}:00`);
            } else {
                targetObj[temp.field_id] = temp.field_value;
            }
        }
        return targetObj;
    }

    _checkBeforeWFAction(con_type, con_ef, li_type, li_ef, line_items) {
        /*
			Set the running map
			then call _checkMandatoryField function
		*/
        this.extrafieldRunningMap[con_type] = this._commonObjCreation({}, con_ef);
        let msg = "";
        if (con_type === "report") msg = "Report level ";
        else if (con_type === "trf") msg = "TRF level ";
        else if (con_type === "Money Request") msg = "Request Advance level ";
        else if (con_type === "Card") msg = "Wallet Load Request level ";
        if (!this._checkMandatoryField(con_type, "", "", {}, "", "", msg)) {
            return false;
        }

        if (li_type) {
            for (let i in line_items) {
                let l_i = line_items[i];
                let native_field = {
                    txn_type: l_i.txn_type ? l_i.txn_type.id || "" : "",
                    category: l_i.category ? l_i.category.id || "" : "",
                    city: l_i.city || { id: "" }
                };
                let temp = li_ef[l_i.txn_id];

                this.extrafieldRunningMap[li_type] = this._commonObjCreation({}, temp);
                if (
                    !this._checkMandatoryField(
                        li_type,
                        "",
                        "",
                        native_field,
                        "",
                        "",
                        ` Expense(${l_i.payee_merchant} ${l_i.amount}) level `
                    )
                ) {
                    // console.log('inside 395',line_items[i]);
                    return false;
                    // break;
                }
            }
        }
        return true;
    }

    _checkSpecificMandatoryField(content_type, native_field, id) {
        let allEF = this._getextraFields(content_type);
        let filteredEF = [];
        let finalEFObj = {
            extraField: {},
            content_type_id: (allEF && allEF[0] && allEF[0].content_type) || "",
            setFormData: false,
            files: {},
            file_delete: {}
        };
        allEF.map(ef => {
            if (ef.is_dependent_on && ef.is_dependent_on.field == native_field) {
                finalEFObj.content_type_id = ef.content_type || "";
                if (ef.is_dependent_on.field_key && ef.is_dependent_on.field_key.includes(id)) {
                    filteredEF.push(ef);
                }
            }
        });
        let efRM = this._getExtraFieldRunningMap(content_type);

        for (let i = 0; i < filteredEF.length; i++) {
            if (
                filteredEF[i].name_type == "BACC" &&
                efRM[filteredEF[i].field_id] &&
                !efRM[`${filteredEF[i].field_id}-BACC`]
            ) {
                UserInfoStores.showToast(`Please give Confirm ${filteredEF[i].name}`);
                return false;
            } else if (
                /* eslint-disable no-undef */
                filteredEF[i].name_type == "BACC" &&
                !efRM[filteredEF[i].field_id] &&
                efRM[`${filteredEF[i].field_id}-BACC`] &&
                ef.is_dependent_on == null
            ) {
                errorStr.push(filteredEF[i].name);
                /* eslint-enable no-undef */
                UserInfoStores.showToast(`Please give ${filteredEF[i].name}`);
                return false;
            } else if (
                filteredEF[i].name_type == "BACC" &&
                efRM[filteredEF[i].field_id] &&
                efRM[`${filteredEF[i].field_id}-BACC`]
            ) {
                if (efRM[filteredEF[i].field_id] !== efRM[`${filteredEF[i].field_id}-BACC`]) {
                    UserInfoStores.showToast(
                        `${filteredEF[i].name} and Confirm ${filteredEF[i].name} is not matching.`
                    );
                    return false;
                }
            }
            if (
                filteredEF[i].name_type == "IFSC" &&
                efRM[filteredEF[i].field_id] &&
                efRM[filteredEF[i].field_id].length != 11
            ) {
                UserInfoStores.showToast(
                    `Please enter a valid ifsc value in ${filteredEF[i].name}.`
                );
                return false;
            }
            if (filteredEF[i].name_type == "date_range" && !filteredEF[i].is_mandate) {
                let fromName = `${filteredEF[i].field_id}-From`;
                let toName = `${filteredEF[i].field_id}-To`;
                // console.log(454,efRM[fromName],efRM[toName]);
                if (efRM[fromName] || efRM[toName]) {
                    if (!efRM[fromName]) {
                        UserInfoStores.showToast(`From ${filteredEF[i].name}`);
                        return false;
                    }
                    if (!efRM[toName]) {
                        UserInfoStores.showToast(`To ${filteredEF[i].name}`);
                        return false;
                    }
                }
            }

            if (filteredEF[i].name_type === "file") {
                let id = filteredEF[i].field_id;
                let newId = `${filteredEF[i].field_id}-NewFiles`;
                let oldId = `${filteredEF[i].field_id}-OldFiles`;
                let fileDel = `${filteredEF[i].field_id}-FileDelete`;
                if (efRM[newId] && (efRM[newId].length || Object.keys(efRM[oldId] || {}).length)) {
                    if (
                        Object.keys(efRM[oldId] || {}).length -
                            (efRM[fileDel] || []).length +
                            efRM[newId].length >
                        filteredEF[i].max_attachment
                    ) {
                        UserInfoStores.showToast(
                            `Max file in ${filteredEF[i].name} that can be attached is ${filteredEF[i].max_attachment}`
                        );
                        return false;
                    }

                    let fileNames_EF = [];
                    if (efRM[fileDel] && efRM[fileDel].length) {
                        finalEFObj.file_delete[id] = efRM[fileDel];
                    }
                    for (let j = 0; j < efRM[newId].length; j++) {
                        if (efRM[newId][j].constructor !== String) {
                            finalEFObj.setFormData = true;
                            fileNames_EF.push(`files-${id}-${j}`);
                            finalEFObj.files[`${id}-${j}`] = {
                                // id: id+'-'+j,
                                file: efRM[newId][j],
                                fileName: efRM[newId][j].name
                            };
                        }
                    }
                    finalEFObj.extraField[id] = fileNames_EF;
                } else {
                    if (
                        Object.keys(efRM[oldId] || {}).length - (efRM[fileDel] || []).length >
                        filteredEF[i].max_attachment
                    ) {
                        UserInfoStores.showToast(
                            `Max file in ${filteredEF[i].name} that can be attached is ${filteredEF[i].max_attachment}`
                        );
                        return false;
                    }
                    if (efRM[fileDel] && efRM[fileDel].length) {
                        finalEFObj.file_delete[id] = efRM[fileDel];
                    }
                }
            } else if (
                filteredEF[i].name_type === "date" ||
                filteredEF[i].name_type === "last_working_day"
            ) {
                finalEFObj.extraField[filteredEF[i].field_id] = efRM[filteredEF[i].field_id]
                    ? Common._formatDate(efRM[filteredEF[i].field_id], "YYYY-MM-DD")
                    : "";
            } else if (filteredEF[i].name_type === "multi_select_dropdown") {
                finalEFObj.extraField[filteredEF[i].field_id] = JSON.stringify(
                    efRM[filteredEF[i].field_id] || []
                );
            } else if (filteredEF[i].name_type == "time" && efRM[filteredEF[i].field_id]) {
                finalEFObj.extraField[filteredEF[i].field_id] = Common.formatTime(
                    efRM[filteredEF[i].field_id]
                );
            } else if (filteredEF[i].name_type === "date_range") {
                let obj = {};
                let fromName = `${filteredEF[i].field_id}-From`;
                let toName = `${filteredEF[i].field_id}-To`;
                obj.from = efRM[fromName] ? Common._formatDate(efRM[fromName], "YYYY-MM-DD") : "";
                obj.to = efRM[toName] ? Common._formatDate(efRM[toName], "YYYY-MM-DD") : "";
                if (!obj.from && !obj.to) finalEFObj.extraField[filteredEF[i].field_id] = "";
                else finalEFObj.extraField[filteredEF[i].field_id] = JSON.stringify(obj);
            } else if (filteredEF[i].is_dependent_on == null) {
                if (filteredEF[i].name_type === "bar_code" && efRM[filteredEF[i].field_id] != "") {
                    finalEFObj.extraField[filteredEF[i].field_id] = efRM[filteredEF[i].field_id];
                } else if (filteredEF[i].name_type !== "bar_code") {
                    if (
                        filteredEF[i].name_type === "number" &&
                        !efRM[filteredEF[i].field_id] &&
                        efRM[filteredEF[i].field_id] !== 0
                    )
                        finalEFObj.extraField[filteredEF[i].field_id] = "";
                    else if (filteredEF[i].name_type !== "number")
                        finalEFObj.extraField[filteredEF[i].field_id] =
                            efRM[filteredEF[i].field_id] || "";
                    else
                        finalEFObj.extraField[filteredEF[i].field_id] =
                            efRM[filteredEF[i].field_id];
                }
            } else {
                if (
                    filteredEF[i].name_type === "number" &&
                    !efRM[filteredEF[i].field_id] &&
                    efRM[filteredEF[i].field_id] !== 0
                )
                    finalEFObj.extraField[filteredEF[i].field_id] = "";
                else if (filteredEF[i].name_type !== "number")
                    finalEFObj.extraField[filteredEF[i].field_id] =
                        efRM[filteredEF[i].field_id] || "";
                else finalEFObj.extraField[filteredEF[i].field_id] = efRM[filteredEF[i].field_id];
            }
            finalEFObj.content_type_id = filteredEF[i].content_type || "";
        }
        return finalEFObj;
    }
    _checkMandatoryField(
        type,
        allEfs,
        expType,
        stateV,
        onb_mand,
        independent,
        extra_message,
        fromPage
    ) {
        //extra_message is used to append in the error message
        let ef = this._getextraFields(type);
        let efRM = this._getExtraFieldRunningMap(type) || {}; // Index is passed from split component to identify each splitted transaction

        let expTypeEFs = [];
        let expTypeIDs = [];
        if (expType) {
            expTypeEFs = this._getExpressionExtraField(expType);
            expTypeIDs = expTypeEFs.map(({ field_id }) => field_id);
        }
        if (type === "transaction") {
            /* eslint-disable no-self-assign */
            ef = ef;
            /* eslint-enable no-self-assign */
            let oldRunningMap = this._getExtraFieldRunningMap("txn_expression") || {};
            let newRunningMap = {};
            oldRunningMap &&
                Object.keys(oldRunningMap).forEach(el => {
                    if (oldRunningMap[el] !== undefined) {
                        newRunningMap[el] = oldRunningMap[el];
                    }
                });
            Object.assign(efRM, newRunningMap);
        }

        if (fromPage === "settlement") {
            ef = allEfs;
        }

        let mandatoryEFList = [];
        let finalEFObj = {
            extraField: {},
            content_type_id: (ef && ef[0] && ef[0].content_type) || "",
            setFormData: false,
            files: {},
            file_delete: {}
        };
        let isValidated = true;
        let errorStr = [];
        let scrollId = "";
        for (let i in expTypeEFs) {
            if (
                expTypeEFs[i].name_type == "date_range" &&
                !efRM[`${expTypeEFs[i].field_id}-From`] &&
                !efRM[`${expTypeEFs[i].field_id}-To`]
            ) {
                let fromname = `From ${ef[i].name}`;
                let toname = `To ${ef[i].name}`;
                scrollId = scrollId || ef[i].field_id;
                errorStr.push(fromname);
                errorStr.push(toname);
                isValidated = false;
            } else if (expTypeEFs[i].name_type == "number") {
                if (!efRM[expTypeEFs[i].field_id] && efRM[expTypeEFs[i].field_id] !== 0) {
                    scrollId = scrollId || expTypeEFs[i].field_id;
                    errorStr.push(expTypeEFs[i].name);
                    isValidated = false;
                } else finalEFObj.extraField[expTypeEFs[i].field_id] = efRM[expTypeEFs[i].field_id];
            } else if (!efRM[expTypeEFs[i].field_id]) {
                scrollId = scrollId || expTypeEFs[i].field_id;
                errorStr.push(expTypeEFs[i].name);
                isValidated = false;
            } else {
                if (
                    expTypeEFs[i].name_type === "date" ||
                    expTypeEFs[i].name_type === "last_working_day"
                ) {
                    finalEFObj.extraField[expTypeEFs[i].field_id] = efRM[expTypeEFs[i].field_id]
                        ? Common._formatDate(efRM[expTypeEFs[i].field_id], "YYYY-MM-DD")
                        : "";
                } else {
                    finalEFObj.extraField[expTypeEFs[i].field_id] =
                        efRM[expTypeEFs[i].field_id] || "";
                }
                finalEFObj.content_type_id = expTypeEFs[i].content_type || "";
            }
        }

        if (onb_mand === "onboarding_mandatory") {
            ef = ef.filter(({ is_mandate, is_dependent_on }) => is_mandate && !is_dependent_on);
        }
        for (let i in ef) {
            if (type === "transaction" && expTypeIDs.includes(ef[i].field_id)) continue;
            if (
                ef[i].name_type == "IFSC" &&
                efRM[ef[i].field_id] &&
                efRM[ef[i].field_id].length != 11
            ) {
                UserInfoStores.showToast(`Please enter a valid ifsc value in ${ef[i].name}.`);
                return false;
            }
            if (ef[i].is_hidden) {
                try {
                    if (this.mode === "edit" && type === "transaction") {
                        let data = ExpenseStores._getTransactionData() || {};
                        let txn_id = data.transaction && data.transaction.txn_id;
                        let extrafield = data.extra_field.extra_fields[txn_id]
                            ? data.extra_field.extra_fields[txn_id]
                            : {};
                        let value = "";
                        Object.values(extrafield).forEach(({ field_id, field_value }) => {
                            if (field_id == ef[i].field_id) {
                                value = efRM[ef[i].field_id] || field_value;
                            }
                        });
                        if (ef[i].is_dependent_on) {
                            if (
                                ef[i].is_dependent_on.field === "txn_type" &&
                                ef[i].is_dependent_on.field_key &&
                                ef[i].is_dependent_on.field_key.length
                            ) {
                                finalEFObj.extraField[ef[i].field_id] = value;
                            } else {
                                finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                            }
                        } else {
                            finalEFObj.extraField[ef[i].field_id] = value;
                        }
                    } else {
                        // this else is for creation mode
                        if (ef[i].name_type === "date" || ef[i].name_type === "last_working_day") {
                            finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id]
                                ? Common._formatDate(efRM[ef[i].field_id], "YYYY-MM-DD")
                                : "";
                        } else if (ef[i].name_type === "multi_select_dropdown") {
                            finalEFObj.extraField[ef[i].field_id] = JSON.stringify(
                                efRM[ef[i].field_id] || []
                            );
                        } else if (ef[i].name_type == "time" && efRM[ef[i].field_id]) {
                            finalEFObj.extraField[ef[i].field_id] = Common.formatTime(
                                efRM[ef[i].field_id]
                            );
                        } else {
                            finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                        }
                    }
                } catch (error) {
                    finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                    console.error("Extrafield Validation for Hidden Fields Breaking");
                }
                continue;
            }
            if (
                ef[i].is_mandate &&
                ((ef[i].name_type != "number" && !efRM[ef[i].field_id]) ||
                    (ef[i].name_type == "number" &&
                        !efRM[ef[i].field_id] &&
                        efRM[ef[i].field_id] !== 0)) &&
                ef[i].name_type !== "file" &&
                ef[i].name_type !== "multi_select_dropdown" &&
                ef[i].name_type !== "date_range"
            ) {
                if (ef[i].is_dependent_on && ef[i].is_dependent_on.field_key) {
                    let fieldName = ef[i].is_dependent_on.field;

                    if (fieldName == "category") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "city") {
                        let id = `${stateV[fieldName].id}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "txn_type") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "extrafield" || fieldName == "extraField") {
                        let allParentValues = efRM[ef[i].is_dependent_on.id] || [];
                        if (ef[i].name_type === "dropdown" || typeof allParentValues === "string")
                            allParentValues = [efRM[ef[i].is_dependent_on.id]];
                        ef[i].is_dependent_on.field_key.forEach(innerEl => {
                            if (allParentValues.includes(innerEl)) {
                                scrollId = scrollId || ef[i].field_id;
                                errorStr.push(ef[i].name);
                                isValidated = false;
                            }
                        });
                    }
                } else {
                    scrollId = scrollId || ef[i].field_id;
                    errorStr.push(ef[i].name);
                    if (fromPage === "loadMoney" && ef[i]?.is_mandate && (ef[i]?.name_type !== "IFSC" && ef[i]?.name_type !== "BACC")) fromPage = "showLoadMoneyMandatory";
                    isValidated = false;
                }
            } else if (
                ef[i].is_mandate &&
                ["multi_select_dropdown"].includes(ef[i].name_type) &&
                (efRM[ef[i].field_id] || []).length === 0
            ) {
                if (ef[i].is_dependent_on && ef[i].is_dependent_on.field_key) {
                    let fieldName = ef[i].is_dependent_on.field;
                    if (fieldName == "category") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "city") {
                        let id = `${stateV[fieldName].id}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "txn_type") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "extrafield" || fieldName == "extraField") {
                        // console.log(421,this.extraFieldMap);
                        let allParentValues = efRM[ef[i].is_dependent_on.id] || [];
                        ef[i].is_dependent_on.field_key.forEach(innerEl => {
                            if (allParentValues.includes(innerEl)) {
                                scrollId = scrollId || ef[i].field_id;
                                errorStr.push(ef[i].name);
                                isValidated = false;
                            }
                        });
                    }
                } else {
                    scrollId = scrollId || ef[i].field_id;
                    errorStr.push(ef[i].name);
                    isValidated = false;
                }
            }
            // else if((['file'].indexOf(ef[i].name_type) !== -1)){
            // }
            else if (
                ef[i].is_mandate &&
                ef[i].name_type === "file" &&
                Object.keys(efRM[`${ef[i].field_id}-OldFiles`] || {}).length === 0 &&
                (!efRM[`${ef[i].field_id}-NewFiles`] ||
                    efRM[`${ef[i].field_id}-NewFiles`].length === 0)
            ) {
                if (ef[i].is_dependent_on && ef[i].is_dependent_on.field_key) {
                    let fieldName = ef[i].is_dependent_on.field;
                    if (fieldName == "category") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "city") {
                        let id = `${stateV[fieldName].id}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "txn_type") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            scrollId = scrollId || ef[i].field_id;
                            errorStr.push(ef[i].name);
                            isValidated = false;
                        }
                    } else if (fieldName == "extrafield" || fieldName == "extraField") {
                        // console.log(421,this.extraFieldMap);
                        let allParentValues = efRM[ef[i].is_dependent_on.id] || [];
                        ef[i].is_dependent_on.field_key.forEach(innerEl => {
                            if (allParentValues.includes(innerEl)) {
                                scrollId = scrollId || ef[i].field_id;
                                errorStr.push(ef[i].name);
                                isValidated = false;
                            }
                        });
                    }
                } else {
                    scrollId = scrollId || ef[i].field_id;
                    errorStr.push(ef[i].name);
                    isValidated = false;
                }
            } else if (ef[i].is_mandate && ef[i].name_type == "time" && !efRM[ef[i].field_id]) {
                scrollId = scrollId || ef[i].field_id;
                errorStr.push(ef[i].name);
                mandatoryEFList.push(`Please give ${ef[i].name}`);
                isValidated = false;
            }
            if (
                ef[i].name_type == "BACC" &&
                efRM[ef[i].field_id] &&
                !efRM[`${ef[i].field_id}-BACC`]
            ) {
                errorStr.push(`Confirm ${ef[i].name}`);
                mandatoryEFList.push(`Please give Confirm ${ef[i].name}`);
                isValidated = false;
            } else if (
                ef[i].name_type == "BACC" &&
                !efRM[ef[i].field_id] &&
                efRM[`${ef[i].field_id}-BACC`] &&
                ef[i].is_dependent_on == null
            ) {
                errorStr.push(ef[i].name);
                mandatoryEFList.push(`Please give ${ef[i].name}`);
                isValidated = false;
            } else if (
                ef[i].name_type == "BACC" &&
                efRM[ef[i].field_id] &&
                efRM[`${ef[i].field_id}-BACC`]
            ) {
                // console.log(985, efRM[ef[i].field_id], efRM[`${ef[i].field_id}-BACC`]);
                if (efRM[ef[i].field_id] !== efRM[`${ef[i].field_id}-BACC`]) {
                    errorStr.push(`${ef[i].name} and Confirm ${ef[i].name}is not matching.`);
                    mandatoryEFList.push(`${ef[i].name} and Confirm ${ef[i].name}is not matching.`);
                    isValidated = false;
                }
            }

            if (ef[i].name_type == "date_range" && !ef[i].is_mandate) {
                let fromName = `${ef[i].field_id}-From`;
                let toName = `${ef[i].field_id}-To`;
                // console.log(454,efRM[fromName],efRM[toName]);
                if (efRM[fromName] || efRM[toName]) {
                    if (!efRM[fromName]) {
                        errorStr.push(`From ${ef[i].name}`);
                        isValidated = false;
                    }
                    if (!efRM[toName]) {
                        errorStr.push(`To ${ef[i].name}`);
                        isValidated = false;
                    }
                }
            } else if (ef[i].is_mandate && ef[i].name_type == "date_range") {
                /*start of date_range validation on dependent field*/
                let fromName = `${ef[i].field_id}-From`;
                let toName = `${ef[i].field_id}-To`;
                if (ef[i].is_dependent_on && ef[i].is_dependent_on.field_key) {
                    let fieldName = ef[i].is_dependent_on.field;
                    if (fieldName == "txn_type" || fieldName == "category") {
                        let id = `${stateV[fieldName]}`;
                        if (ef[i].is_dependent_on.field_key.includes(id)) {
                            if (!efRM[fromName]) {
                                errorStr.push(`From ${ef[i].name}`);
                                scrollId = scrollId || ef[i].field_id;
                                isValidated = false;
                            }
                            if (!efRM[toName]) {
                                errorStr.push(`To ${ef[i].name}`);
                                scrollId = scrollId || ef[i].field_id;
                                isValidated = false;
                            }
                        }
                    }
                } else {
                    if (!efRM[fromName]) {
                        scrollId = scrollId || ef[i].field_id;
                        errorStr.push(`From ${ef[i].name}`);
                        isValidated = false;
                    }
                    if (!efRM[toName]) {
                        scrollId = scrollId || ef[i].field_id;
                        errorStr.push(`To ${ef[i].name}`);
                        isValidated = false;
                    }
                }
            }
            /*End of date_range validation on dependent field*/

            // for backfilling default values for hidden extrafield
            if (
                ef[i].is_invisible &&
                !ef[i].is_dependent_on &&
                ef[i].default_selected_value &&
                !efRM[ef[i].field_id]
            ) {
                finalEFObj.extraField[ef[i].field_id] = ef[i].default_selected_value;
                continue;
            }
            // Backfilling Ended

            if (ef[i].name_type === "file") {
                let id = ef[i].field_id;
                let newId = `${ef[i].field_id}-NewFiles`;
                let oldId = `${ef[i].field_id}-OldFiles`;
                let fileDel = `${ef[i].field_id}-FileDelete`;
                if (efRM[newId] && (efRM[newId].length || Object.keys(efRM[oldId] || {}).length)) {
                    if (
                        Object.keys(efRM[oldId] || {}).length -
                            (efRM[fileDel] || []).length +
                            efRM[newId].length >
                        ef[i].max_attachment
                    ) {
                        UserInfoStores.showToast(
                            `Max file in ${ef[i].name} that can be attached is ${ef[i].max_attachment}`
                        );
                        return false;
                    }

                    let fileNames_EF = [];
                    if (efRM[fileDel] && efRM[fileDel].length) {
                        finalEFObj.file_delete[id] = efRM[fileDel];
                    }
                    for (let j = 0; j < efRM[newId].length; j++) {
                        if (efRM[newId][j].constructor !== String) {
                            finalEFObj.setFormData = true;
                            fileNames_EF.push(`files-${id}-${j}`);
                            finalEFObj.files[`${id}-${j}`] = {
                                // id: id+'-'+j,
                                file: efRM[newId][j],
                                fileName: efRM[newId][j].name
                            };
                        }
                    }
                    finalEFObj.extraField[id] = fileNames_EF;
                } else {
                    if (
                        Object.keys(efRM[oldId] || {}).length - (efRM[fileDel] || []).length >
                        ef[i].max_attachment
                    ) {
                        UserInfoStores.showToast(
                            `Max file in ${ef[i].name} that can be attached is ${ef[i].max_attachment}`
                        );
                        return false;
                    }
                    if (efRM[fileDel] && efRM[fileDel].length) {
                        finalEFObj.file_delete[id] = efRM[fileDel];
                    }
                }
                ef[i].is_dependent_on;
                try {
                    let is_dependent = ef[i].is_dependent_on;
                    if (is_dependent && is_dependent.field.toLowerCase() == "extrafield") {
                        if (
                            Array.isArray(is_dependent.field_key) &&
                            !is_dependent.field_key.includes(efRM[is_dependent.id]) &&
                            efRM[oldId]
                        ) {
                            finalEFObj.file_delete[id] = Object.keys(efRM[oldId]);
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            } else if (ef[i].name_type === "date" || ef[i].name_type === "last_working_day") {
                finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id]
                    ? Common._formatDate(efRM[ef[i].field_id], "YYYY-MM-DD")
                    : "";
            } else if (ef[i].name_type === "multi_select_dropdown") {
                finalEFObj.extraField[ef[i].field_id] = JSON.stringify(efRM[ef[i].field_id] || []);
            } else if (ef[i].name_type == "time" && efRM[ef[i].field_id]) {
                finalEFObj.extraField[ef[i].field_id] = Common.formatTime(efRM[ef[i].field_id]);
            } else if (ef[i].name_type === "date_range") {
                let obj = {};
                let fromName = `${ef[i].field_id}-From`;
                let toName = `${ef[i].field_id}-To`;
                obj.from = efRM[fromName] ? Common._formatDate(efRM[fromName], "YYYY-MM-DD") : "";
                obj.to = efRM[toName] ? Common._formatDate(efRM[toName], "YYYY-MM-DD") : "";
                if (!obj.from && !obj.to) finalEFObj.extraField[ef[i].field_id] = "";
                else finalEFObj.extraField[ef[i].field_id] = JSON.stringify(obj);
            } else if (
                ef[i].name_type === "con_type" &&
                efRM[ef[i].field_id] &&
                efRM[ef[i].field_id] !== ""
            ) {
                if (efRM[ef[i].field_id]["rct_id"]) {
                    finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id]["rct_id"];
                } else {
                    finalEFObj.extraField[ef[i].field_id] = "";
                }
            } else if (ef[i].is_dependent_on == null) {
                if (ef[i].name_type === "bar_code" && efRM[ef[i].field_id] != "") {
                    finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                } else if (ef[i].name_type !== "bar_code") {
                    if (
                        ef[i].name_type === "number" &&
                        !efRM[ef[i].field_id] &&
                        efRM[ef[i].field_id] !== 0
                    )
                        finalEFObj.extraField[ef[i].field_id] = "";
                    else if (ef[i].name_type !== "number")
                        finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id] || "";
                    else finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                }
            } else {
                if (
                    ef[i].name_type === "number" &&
                    !efRM[ef[i].field_id] &&
                    efRM[ef[i].field_id] !== 0
                ) {
                    finalEFObj.extraField[ef[i].field_id] = "";
                } else if (ef[i].name_type !== "number") {
                    finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id] || "";
                } else {
                    finalEFObj.extraField[ef[i].field_id] = efRM[ef[i].field_id];
                }
            }
            if (ef[i].name_type === "frequent_flyer_number") {
                let ffData = {};
                if (efRM[ef[i].field_id] && typeof efRM[ef[i].field_id] === "string") {
                    ffData = JSON.parse(efRM[ef[i].field_id]);
                } else {
                    ffData = efRM[ef[i].field_id];
                }
                let flag = false;
                if (ffData) {
                    Object.entries(ffData).forEach(([key, value]) => {
                        if (!value) {
                            UserInfoStores.showToast(i18n.t("err.pleaseFillFreqFlyNo"));
                            flag = true;
                        }
                    });
                }
                if (flag) {
                    return false;
                }
                if (ffData && Object.keys(ffData).length) {
                    finalEFObj.extraField[ef[i].field_id] = JSON.stringify(ffData);
                }
            }
            finalEFObj.content_type_id = ef[i].content_type || "";
        }
        // console.log('finalEFObj',finalEFObj,errorStr);
        // return false;
        if (independent == true) {
            return finalEFObj;
        }
        if (!isValidated) {
            if (type === "trf") {
                Common._scrollToElement("id", scrollId, type, -50);
            } else if (type === "Money Request") {
                Common._scrollToElement("id", scrollId, "Money-Request", 0);
            } else {
                Common._scrollToElement("id", scrollId, type, 0);
            }
            if (errorStr.length == 1)
                if (fromPage === "split") {
                    UserInfoStores.showToast(
                        `For Split - ${parseInt(type.replace("split-", "")) + 1} - ${i18n.t(
                            "err.pleaseFillThe"
                        )} ${extra_message || ""} ${i18n.t("flexi.field")} - ${errorStr.join(" ")}`
                    );
                } else {
                    UserInfoStores.showToast(
                        fromPage === "showLoadMoneyMandatory" ? i18n.t("err.updateProfileMandatoryFields") : `${i18n.t("err.pleaseFillThe")} ${extra_message || ""} ${i18n.t("flexi.field"
                        )} - ${errorStr.join(" ")} `
                    );
                }
            else
                UserInfoStores.showToast(
                    fromPage === "showLoadMoneyMandatory" ? i18n.t("err.updateProfileMandatoryFields") 
                    : `${i18n.t("err.pleaseFillThe")} ${extra_message || ""} ${i18n.t(
                        "flexi.field"
                    )} - ${errorStr.join(", ")}` 
                );
            return false;
        }
        return finalEFObj;
    }
    _createExtraField(resultStr, res_code) {
        this.result = resultStr;
        this.res_code = res_code;
        this.emit("change");
    }
    _deleteExtraFields(resultStr, res_code) {
        this.result = resultStr;
        this.res_code = res_code;
        this.emit("change");
    }
    _editExtraField(resultStr, res_code) {
        this.result = resultStr;
        this.res_code = res_code;
        this.emit("change");
    }

    _editExtraFieldMain(type, value) {
        this.extraFields[type] = value;
        this.emit("change", "typing");
    }
    _editExtraFieldDependent(type, value) {
        // console.log("inside _editExtraFieldDependent",value);
        this.extraFields["dependent"] = value;
        this.emit("change", "typingDependent");
    }

    _getallextraFields(type) {
        if (this.preDefinedExtraFields[type] && this.extraFields[type]) {
            let ef = this.preDefinedExtraFields[type].concat(this.extraFields[type]);
            return ef;
        } else if (!this.preDefinedExtraFields[type] || this.extraFields[type]) {
            let ef = this.extraFields[type];
            return ef;
        } else if (this.preDefinedExtraFields[type] || !this.extraFields[type]) {
            let ef = this.preDefinedExtraFields[type];
            return ef;
        }
        return [];
    }
    _getextraFields(type) {
        let ef = this.extraFields[type] || [];

        return ef || [];
    }
    _getChildParentMap(type) {
        if (type == "txn_expression") {
            type = "transaction";
        }
        let ef = this.extraFields[type] || [];
        const map = {};
        const depMap = {};
        for (let i = 0; i < ef.length; i++) {
            if (
                ef[i].is_dependent_on !== null &&
                ef[i].is_dependent_on !== "" &&
                ef[i].is_dependent_on.field !== "extraField"
            ) {
                let values = [];
                if (["dropdown", "multi_select_dropdown"].includes(ef[i].name_type)) {
                    values = Object.keys(ef[i].values);
                } else if (["number", "date", "date_range"].includes(ef[i].name_type)) {
                    values = ef[i].is_dependent_on.field_key;
                } else {
                    try {
                        if (ef[i].values) {
                            let val =
                                typeof ef[i].values === "string"
                                    ? JSON.parse(ef[i].values)
                                    : ef[i].values;
                            values = Object.keys(val);
                        }
                    } catch (error) {
                        console.error(error);
                    }
                }
                map[ef[i].field_id] = { dependent: values, field: ef[i].is_dependent_on.field };
            } else if (
                ef[i].is_dependent_on !== null &&
                ef[i].is_dependent_on !== "" &&
                ef[i].is_dependent_on.field === "extraField"
            ) {
                let values = [];
                values.push(ef[i].is_dependent_on.id);
                map[ef[i].field_id] = { dependent: values, field: ef[i].is_dependent_on.field };
            } else {
                map[ef[i].field_id] = { dependent: [] };
            }
        }
        for (let i in map) {
            depMap[i] = [];
            depMap[i] = this._setDependentFields(map, i, depMap, i) || [];
            // console.log('_setDependentFields',depMap[i]);
        }
        return depMap;
    }
    _setDependentFields(map, i, dict, key) {
        if (map[i] && map[i].dependent && map[i].dependent.length) {
            for (let id of map[i].dependent) {
                if (map[id] && map[id].dependent.length) {
                    dict[key].push({ id, field: map[i].field });
                    this._setDependentFields(map[id], id, dict, key);
                } else {
                    dict[key].push({ id, field: map[i].field });
                }
            }

            return dict[key];
        }
        return null;
    }
    _setParticluarExtraField(extraFields) {
        this.particularEf = extraFields;
        this.emit("change", "particular");
    }
    _getParticluarExtraField() {
        return this.particularEf;
    }
    _clearParticluarExtraField() {
        this.particularEf = {};
    }
    _getAllExtraFieldsNew(ef, resource, mode, ct_id) {
        this.extraFields[resource] = ef;
        if (!ct_id) {
            this.extraFieldNative = {};
            this.extraFieldNative["category"] = [];
            this.extraFieldNative["txn_type"] = [];
            this.extraFieldNative["city"] = [];
        }
        this.reverseMap[resource] = {};
        this.efMapforExpressionOrComposite[resource] = {};
        this.extraFieldMap[resource] = {};

        let creationView = this.mode === "create" ? true : false;
        if (this.mode === "create") {
            creationView = true;
        } else {
            creationView = false;
        }
        if (mode === "userEdit") creationView = false;

        let reverseMap = {};
        for (let i in ef) {
            reverseMap[ef[i].field_id] = ef[i];
            this.reverseMap[resource][ef[i].field_id] = ef[i];
            this.extraFieldMap[resource][ef[i].field_id] = "";
            if (
                ["composite", "expression"].includes(ef[i].field_type) &&
                Object.keys(ef[i].is_expression).length > 0
            ) {
                let exp = ef[i].is_expression[ef[i].field_type];
                exp?.split(",").forEach(e => {
                    if (!["(", ")", "+", "-", "*", "%", "/", "constant"].includes(e)) {
                        if (!this.efMapforExpressionOrComposite[resource][ef[i].is_expression[e]]) {
                            this.efMapforExpressionOrComposite[resource][
                                ef[i].is_expression[e]
                            ] = [];
                        }
                        if (
                            !this.efMapforExpressionOrComposite[resource][
                                ef[i].is_expression[e]
                            ].includes(ef[i].field_id)
                        ) {
                            this.efMapforExpressionOrComposite[resource][
                                ef[i].is_expression[e]
                            ].push(ef[i].field_id);
                        }
                    }
                });
            }
            if (creationView) {
                if (!this.extrafieldRunningMap[resource]) this.extrafieldRunningMap[resource] = {};
                if (
                    ["composite", "expression"].includes(ef[i].field_type) &&
                    Object.keys(ef[i].is_expression).length > 0
                ) {
                    this._setCompositeOrExpValue(ef[i], resource);
                }
                if (
                    ["text", "number", "BACC", "IFSC", "prefix", "postfix"].includes(
                        ef[i].name_type
                    )
                ) {
                    let el = ef[i];
                    let allValues = el.values;
                    if (
                        ef[i].default_selected_value &&
                        (!ef[i].is_dependent_on || ef[i].parent_map_id)
                    ) {
                        if (
                            ef[i].name_type === "text" &&
                            ef[i].field_type === null &&
                            (ef[i].unique_org || ef[i].unique_user)
                        ) {
                            this.extrafieldRunningMap[resource][ef[i].field_id] = ef[
                                i
                            ].default_selected_value.toUpperCase();
                        } else {
                            this.extrafieldRunningMap[resource][ef[i].field_id] =
                                ef[i].default_selected_value;
                        }
                    }
                    if (allValues && ef[i].is_dependent_on && el.is_dependent_on.id) {
                        let vals = {};
                        try {
                            vals = JSON.parse(el.values);
                        } catch (e) {
                            // console.log(2212, el);
                        }
                        let value;

                        value = vals[this.extrafieldRunningMap[resource][el.is_dependent_on.id]];

                        value = value === 0 ? `${value}` : value;
                        if (["text", "date"].includes(el.name_type) && !value) value = "";

                        this.extrafieldRunningMap[resource][el.field_id] = value;
                    }
                }
                if (ef[i].name_type === "dropdown" && ef[i].default_selected_value) {
                    // This logic is for the fields which are dependent fields and the parent has some default selection
                    if (!ef[i].is_dependent_on) {
                        this._setExtraFieldDDRunningMap(
                            ef[i].default_selected_value,
                            ef[i].field_id,
                            resource
                        );
                    } else if (ef[i].is_dependent_on && ef[i].is_dependent_on.id) {
                        let el = ef[i];
                        const efDepValueInRunningMap = this.extrafieldRunningMap[resource][
                            el.is_dependent_on.id
                        ];
                        const currentEfValueInRunningMap = this.extrafieldRunningMap[resource][
                            el.field_id
                        ];

                        try {
                            if (
                                !currentEfValueInRunningMap &&
                                Array.isArray(el.is_dependent_on.field_key)
                            ) {
                                if (el.is_dependent_on.field_key.includes(efDepValueInRunningMap))
                                    this.extrafieldRunningMap[resource][el.field_id] = JSON.parse(
                                        el.default_selected_value
                                    )[efDepValueInRunningMap];
                            }
                        } catch (error) {
                            console.error(error);
                        }
                    }
                }

                if (
                    ef[i].name_type === "multi_select_dropdown" &&
                    ef[i].default_selected_value &&
                    !ef[i].is_dependent_on
                ) {
                    // This logic is for the fields which are dependent fields and the parent has some default selection
                    this._setExtraFieldDDRunningMap(
                        JSON.parse(ef[i].default_selected_value || "null"),
                        ef[i].field_id,
                        resource
                    );
                }
                if (ef[i]?.name_type === "date" && ef[i]?.default_selected_value) {
                    this._setExtraFieldDDRunningMap(
                        ef[i]?.default_selected_value,
                        ef[i]?.field_id,
                        resource
                    );
                }
            }

            if (ef[i].is_dependent_on && ef[i].is_dependent_on.field === "category") {
                this.extraFieldNative["category"].push(ef[i].field_id);
                if (ef[i].guardian && ef[i].guardian.length) {
                    for (let j = 0; j < ef[i].guardian.length; j++) {
                        // This check is because in guardian sometimes null is coming
                        if (ef[i].guardian[j]) {
                            this.extraFieldNative["category"].push(parseInt(ef[i].guardian[j]));
                        }
                    }
                }
            } else if (ef[i].is_dependent_on && ef[i].is_dependent_on.field === "txn_type") {
                if (!this.extraFieldNative["txn_type"].includes(ef[i].field_id))
                    this.extraFieldNative["txn_type"].push(ef[i].field_id);
                if (ef[i].guardian && ef[i].guardian.length) {
                    for (let j = 0; j < ef[i].guardian.length; j++) {
                        if (
                            ef[i].guardian[j] &&
                            !this.extraFieldNative["txn_type"].includes(parseInt(ef[i].guardian[j]))
                        )
                            this.extraFieldNative["txn_type"].push(parseInt(ef[i].guardian[j]));
                    }
                }
            } else if (ef[i].is_dependent_on && ef[i].is_dependent_on.field === "city") {
                this.extraFieldNative["city"].push(ef[i].field_id);
                if (ef[i].guardian && ef[i].guardian.length) {
                    for (let j = 0; j < ef[i].guardian.length; j++) {
                        if (ef[i].guardian[j]) {
                            this.extraFieldNative["city"].push(parseInt(ef[i].guardian[j]));
                        }
                    }
                }
            } else if (ef[i].is_dependent_on && ef[i].is_dependent_on.field === "extraField") {
                try {
                    let depEfId = ef[i].is_dependent_on.id;
                    let depEfFieldKeys = ef[i].is_dependent_on.field_key;
                    if (
                        this.extrafieldRunningMap[resource] &&
                        !this.extrafieldRunningMap[resource][ef[i].field_id] &&
                        this.extrafieldRunningMap[resource][depEfId] &&
                        Array.isArray(depEfFieldKeys) &&
                        depEfFieldKeys.includes(this.extrafieldRunningMap[resource][depEfId])
                    ) {
                        let val = typeof ef[i].values === "string" && JSON.parse(ef[i].values);
                        if (
                            val &&
                            isJson(val) &&
                            val[this.extrafieldRunningMap[resource][depEfId]]
                        ) {
                            this.extrafieldRunningMap[resource][ef[i].field_id] =
                                val[this.extrafieldRunningMap[resource][depEfId]];
                        }

                        const { name_type, default_selected_value, field_id } = ef[i];
                        if (
                            name_type === "dropdown" &&
                            default_selected_value &&
                            typeof default_selected_value === "string" &&
                            mode !== "userEdit"
                        ) {
                            this.extrafieldRunningMap[resource][field_id] = JSON.parse(
                                default_selected_value
                            )[this.extrafieldRunningMap[resource][depEfId]];
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            }
            if (ef[i].name_type === "con_type") {
                // storing all the fields which are mapped to con type.
                const arr = Object.keys(ef[i].additional_map || {}) || [];
                this.containerMappedFields = [...this.containerMappedFields, ...arr];
            }
            // this.concatMappedFields - will store key/value pair of concat or expression extrafields and parent.
            if (
                ["composite", "expression"].includes(ef[i].field_type) &&
                Object.keys(ef[i].is_expression).length > 0
            ) {
                const field = ef[i];
                const { is_expression, field_type, field_id } = field;
                for (let i in is_expression) {
                    if (
                        i !== field_type &&
                        typeof is_expression[i] !== "boolean" &&
                        !i.includes("native_key") &&
                        !(is_expression[i] in this.concatMappedFields)
                    ) {
                        this.concatMappedFields[is_expression[i]] = field_id;
                    } else if (i.includes("native_key") && is_expression[i] === "amount") {
                        this.concatMappedFields[`amount-${field_id}`] = field_id;
                    }
                }
            }
        }
        if (!ct_id) {
            this.extraFieldNativeDependentFields = this.extraFieldNative["category"].concat(
                this.extraFieldNative["txn_type"],
                this.extraFieldNative["city"]
            );
        }
        this.extrafieldRunningMap[resource] = Object.assign(
            {},
            this.extraFieldMap[resource],
            this.extrafieldRunningMap[resource]
        );
        if (resource === "transaction" && this.current_txn_type) {
            let efFetched = true;
            this._initExtraFieldRunningMapValues(resource, this.current_txn_type, efFetched);
        }
        this.emit("change", resource);
    }
    _setCompositeOrExpValue(el, con_type, newItem) {
        let compositeObj = {};
        if (!this.extrafieldRunningMap[con_type]) {
            this.extrafieldRunningMap[con_type] = {};
        }
        const { id, field_key = [] } = el.is_dependent_on || {};
        const tempKey = this.extrafieldRunningMap[con_type][id];
        let isValid = true;
        if (id && field_key.length > 0 && !field_key.includes(tempKey)) {
            isValid = false;
        }
        // console.log(2474, '_setCompositeOrExpValue:::', el, isValid);

        if (el && el.is_expression && el.is_expression[el.field_type] && isValid) {
            el.is_expression[el.field_type].split(",").forEach((e, i, els) => {
                if (e !== ")" && e !== "(") {
                    if (e.includes("native_key")) {
                        if (
                            el.is_expression[e] == "amount" &&
                            ExpenseStores._getAnyField("currency_amount", con_type) &&
                            ExpenseStores._getAnyField("currency_amount") !== ""
                        ) {
                            let amount = `${ExpenseStores._getAnyField("currency_amount", con_type)}`;
                            if (amount.split(".")[1] == "00" || amount.split(".")[1] == "0") {
                                amount = amount.split(".")[0];
                            }
                            compositeObj[i] = amount;
                        } else if (
                            el.is_expression[e] == "txn_date" &&
                            ExpenseStores._getAnyField("txn_date")
                        ) {
                            if (
                                typeof ExpenseStores._getAnyField(el.is_expression[e]) === "object"
                            ) {
                                compositeObj[i] = Common._formatDate(
                                    ExpenseStores._getAnyField(el.is_expression[e]),
                                    "YYYY-MM-DD"
                                );
                            } else {
                                compositeObj[i] = ExpenseStores._getAnyField(
                                    el.is_expression[e]
                                ).substring(0, 10);
                            }
                        } else if (
                            (ExpenseStores._getAnyField(el.is_expression[e]),
                            con_type &&
                                ExpenseStores._getAnyField(el.is_expression[e], con_type) !== "")
                        ) {
                            compositeObj[i] = ExpenseStores._getAnyField(
                                el.is_expression[e],
                                con_type
                            );
                        }
                    } else if (e.includes("constant")) {
                        compositeObj[i] = el.is_expression[e];
                    } else if (!isNaN(+e)) {
                        compositeObj[i] = e;
                    } else if (
                        this.extrafieldRunningMap[con_type] &&
                        this.extrafieldRunningMap[con_type][el.is_expression[e]]
                    ) {
                        const val = this.extrafieldRunningMap[con_type][el.is_expression[e]];
                        const nameTypeOfTime = this.reverseMap[con_type]?.[el.is_expression[e]]?.name_type;
                        if (nameTypeOfTime === "time") {
                            compositeObj[i] = Common.formatTime(val);
                        } else if (nameTypeOfTime === "date") {
                            // HEPIT-11727: Handling the date in composite expression also
                            compositeObj[i] = Common._formatDate(val, "YYYY-MM-DD");
                        } else {
                            compositeObj[i] = val;
                        }
                    } else if (["+", "*", "-", "/", "%"].includes(e)) {
                        compositeObj[i] = e;
                    } else if (e.includes("round")) {
                        compositeObj[i] = "Math.roundOff(";
                    } else if (["+", "-", "*"].includes(els[i - 1])) {
                        compositeObj[i] = 0;
                    } else if (["/", "%"].includes(els[i - 1])) {
                        compositeObj[i] = 1;
                    }
                }
            });
        }
        if (el.is_expression[el.field_type]) {
            // && Object.keys(compositeObj).length === el.is_expression[el.field_type].split(',').length - 2) {
            if (!this.extrafieldRunningMap[con_type][el.field_id]) {
                this.extrafieldRunningMap[con_type][el.field_id] = "";
            }
            if (el.field_type === "composite") {
                if (
                    this.extrafieldRunningMap[con_type][el.field_id] !==
                    Object.values(compositeObj).join("")
                ) {
                    if (el.name_type === "text") {
                        const expObj = el.is_expression || {};
                        const values = Object.values(compositeObj).join("");
                        if (expObj.case_sensitive === false) {
                            this.extrafieldRunningMap[con_type][el.field_id] = values.toUpperCase();
                        } else {
                            this.extrafieldRunningMap[con_type][el.field_id] = values;
                        }
                        this.efMapforExpressionOrComposite &&
                            this.efMapforExpressionOrComposite[con_type] &&
                            this.efMapforExpressionOrComposite[con_type][el.field_id] &&
                            this.efMapforExpressionOrComposite[con_type][el.field_id].forEach(e => {
                                this._setCompositeOrExpValue(
                                    this.reverseMap[con_type][e],
                                    con_type,
                                    ""
                                );
                            });
                    } else if (el.name_type === "dropdown") {
                        let val = {};
                        let valueToTake = "";
                        if (el.is_dependent_on && el.is_dependent_on.field) {
                            switch (el.is_dependent_on.field) {
                                case "txn_type":
                                    valueToTake = this.current_txn_type;
                                    break;
                                case "city":
                                    valueToTake = ExpenseStores._getAnyField("city_id");
                                    break;
                                case "category":
                                    valueToTake = ExpenseStores._getAnyField("category_id");
                                    break;
                                default:
                                    valueToTake = "";
                            }
                        }
                        if (
                            el.is_dependent_on &&
                            Array.isArray(el.is_dependent_on.field_key) &&
                            el.is_dependent_on.field_key.includes(
                                this.extrafieldRunningMap[con_type][el.is_dependent_on.id]
                            )
                        ) {
                            val =
                                el.values[
                                    this.extrafieldRunningMap[con_type][el.is_dependent_on.id]
                                ];
                        } else if (
                            el.is_dependent_on &&
                            ["txn_type", "city", "category"].includes(el.is_dependent_on.field) &&
                            Array.isArray(el.is_dependent_on.field_key) &&
                            el.is_dependent_on.field_key.includes(`${valueToTake}`)
                        ) {
                            val = el.values[valueToTake];
                        } else {
                            val = el.values;
                        }
                        if (Object.values(val).includes(Object.values(compositeObj).join(""))) {
                            this.extrafieldRunningMap[con_type][el.field_id] = Object.values(
                                compositeObj
                            ).join("");
                            this.extraFieldMap[con_type][el.field_id] = Object.values(
                                compositeObj
                            ).join("");
                            if (Array.isArray(el.guardian) && el.guardian.length > 0) {
                                this._setExtraFieldDDRunningMap(
                                    Object.values(compositeObj).join(""),
                                    el.field_id,
                                    con_type
                                );
                            }
                            if (newItem) {
                                if (!newItem[el.field_id]) {
                                    newItem[el.field_id] = "";
                                }
                                newItem[el.field_id] = Object.values(compositeObj).join("");
                            }
                        } else {
                            this.extrafieldRunningMap[con_type][el.field_id] = "";
                            if (Array.isArray(el.guardian) && el.guardian.length > 0)
                                this._emptyValueOfGuardian(
                                    el,
                                    el.guardian,
                                    con_type,
                                    newItem,
                                    "composite"
                                );
                            if (newItem) {
                                newItem[el.field_id] = "";
                            }
                        }
                    }
                }
            } else if (el.field_type === "expression") {
                try {
                    let evalExpr = Object.values(compositeObj).join("");
                    if (evalExpr.includes("Math.roundOff(")) {
                        evalExpr += ")";
                    }
                    let val = eval(evalExpr);
                    if (val === undefined || val === null) val = "";
                    if (this.extrafieldRunningMap[con_type][el.field_id] !== val || val === 0) {
                        if (typeof val === "number" && !evalExpr.includes("Math.roundOff(")) {
                            val = val.toFixed(2);
                        }
                        this.extrafieldRunningMap[con_type][el.field_id] = `${val}`;
                        if (Array.isArray(el.guardian) && el.guardian.length > 0) {
                            this._setExtraFieldDDRunningMap(eval(evalExpr), el.field_id, con_type);
                        }
                        if (
                            this.efMapforExpressionOrComposite[con_type] &&
                            this.efMapforExpressionOrComposite[con_type][el.field_id]
                        ) {
                            this._triggerCompositeValue(con_type, el.field_id);
                        }
                    }
                } catch (error) {
                    this.extrafieldRunningMap[con_type][el.field_id] = "";
                }
            }
        } else if (el.field_type === "date_diff") {
            // This is being handled in date_diff field type to evaluate the expression
            try {
                const { format, from_date: fDate, to_date: tDate } = el.is_expression || {};
                const fDateValue = this.extrafieldRunningMap?.[con_type]?.[fDate];
                const tDateValue = this.extrafieldRunningMap?.[con_type]?.[tDate];
                if (format === "days" || format === "day"  && fDateValue instanceof Date && tDateValue instanceof Date) {
                    const formattedFDate =  Common._formatDate(fDateValue, "YYYY/MM/DD");
                    const formattedTDate =  Common._formatDate(tDateValue, "YYYY/MM/DD");
                    this.extrafieldRunningMap[con_type][el.field_id] = moment(formattedTDate).diff(moment(formattedFDate), "days") || "0";
                    if (
                        this.efMapforExpressionOrComposite[con_type] &&
                        this.efMapforExpressionOrComposite[con_type][el.field_id]
                    ) {
                        // Here again triggering composite because this EF can be used in any other expression
                        this._triggerCompositeValue(con_type, el.field_id);
                    }
                } else {
                    this.extrafieldRunningMap[con_type][el.field_id] = "";
                }
            } catch(e) {
                console.log('error in field_type of date_diff', e);
            }
        } else {
            this.extrafieldRunningMap[con_type][el.field_id] = "";
            if (Array.isArray(el.guardian) && el.guardian.length > 0) {
                this._emptyValueOfGuardian(el, el.guardian, con_type, newItem, "composite");
            }
        }
    }
    _triggerCompositeValue(con_type, id) {
        if (con_type === "txn_expression") {
            this.efMapforExpressionOrComposite[con_type] = this.efMapforExpressionOrComposite[
                "transaction"
            ];
        }
        if (!this.efMapforExpressionOrComposite[con_type]) {
            this.efMapforExpressionOrComposite[con_type] = {};
        }
        if (id === "currency_amount") {
            this.efMapforExpressionOrComposite[con_type][id] &&
                this.efMapforExpressionOrComposite[con_type][id].forEach(el => {
                    this._setCompositeOrExpValue(this.reverseMap[con_type][el], con_type, "");
                });
            id = "amount";
        }

        if (this.efMapforExpressionOrComposite[con_type][id]) {
            // console.log(2691, "_triggerCompositeValue:::", id, this.efMapforExpressionOrComposite[con_type][id]);
            this.efMapforExpressionOrComposite[con_type][id].forEach(el => {
                let filterData =
                    this.reverseMap && this.reverseMap[con_type] && this.reverseMap[con_type][el];
                if (!filterData && con_type === "txn_expression") {
                    filterData = this.extraFields[con_type].filter(
                        unit => +el === +unit.field_id
                    )?.[0];
                }
                filterData && this._setCompositeOrExpValue(filterData, con_type, "");
            });
            this.emit("change", "composite");
        }
    }
    _getExtraFieldNative() {
        return this.extraFieldNative;
    }
    _getextraFieldNativeDependentFields() {
        return this.extraFieldNativeDependentFields;
    }
    _getAllExtraFields(extraFields, resource) {
        for (const i in extraFields) {
            extraFields[i].fieldValue = "";
            extraFields[i].errStr = "";
            if (extraFields[i].name_type === "file") extraFields[i].billUrls = [];
        }
        this.extraFields[resource] = extraFields;
        this.emit("change", resource);
    }
    _getPreDefinedExtraFieldTypes(extraFields, resource) {
        for (const i in extraFields) {
            extraFields[i].fieldValue = "";
            extraFields[i].errStr = "";
        }
        this.preDefinedExtraFields[resource] = extraFields;
        this.emit("change");
    }
    _setOverrideFields(overrideFields) {
        this.overrideFields = overrideFields;
        this.emit("change", "overrideFields");
    }
    _getOverrideFields() {
        return this.overrideFields;
    }
    _setAllSearchable(data) {
        this.setAllSearchableData = data;
        this.emit("change", "ALL_SEARCHABLE");
    }
    _getAllSearchable() {
        return this.setAllSearchableData;
    }
    _getExtraFieldByResource(resource) {
        return this.extraFields[resource];
    }
    saveFieldMap(mapForExpressionExtraField) {
        this.mapForExpressionExtraField = Object.assign({}, mapForExpressionExtraField);
    }
    getFieldMap() {
        return this.mapForExpressionExtraField;
    }
    saveOperationToPerform(operation) {
        this.operation = operation;
    }
    getOperationToPerform() {
        return this.operation;
    }
    // This function will restore values coming from API to corresponding extrafields.
    _restoreExtrafieldValue(extrafield, containerType, comingFrom, page) {
        let extrafieldData = {};
        extrafield &&
            Object.values(extrafield).forEach(ef => {
                if (ef.name_type == "date_range") {
                    let fromId = `${ef.field_id}-From`;
                    let toId = `${ef.field_id}-To`;
                    try {
                        let val = JSON.parse(ef.field_value);
                        if (val.from && val.from != "Invalid Date")
                            extrafieldData[fromId] = new Date(
                                Common._formatDate(val.from, "YYYY/MM/DD HH:mm:ss")
                            );
                        if (val.to && val.to != "Invalid Date")
                            extrafieldData[toId] = new Date(
                                Common._formatDate(val.to, "YYYY/MM/DD HH:mm:ss")
                            );
                    } catch (e) {
                        //invalid value saved in daterange format
                    }
                } else if (ef.name_type == "BACC") {
                    let confirmId = `${ef.field_id}-BACC`;
                    extrafieldData[ef.field_id] = ef.field_value;
                    extrafieldData[confirmId] = ef.field_value;
                } else if (ef.name_type == "file") {
                    if (comingFrom === "extrafieldComponent") {
                        let oldFiles = `${ef.field_id}-OldFiles`;
                        let newFiles = `${ef.field_id}-NewFiles`;
                        extrafieldData[oldFiles] = ef.field_value["OldFiles"];
                        extrafieldData[newFiles] = ef.field_value["NewFiles"];
                    } else {
                        const oldFiles = `${ef.field_id}-OldFiles`;
                        const newFiles = `${ef.field_id}-NewFiles`;
                        extrafieldData[oldFiles] = ef.field_value;
                        extrafieldData[newFiles] = [];
                        extrafieldData[`${ef.field_id}-FileDelete`] = [];
                    }
                } else if (ef.name_type === "date" || ef.name_type === "last_working_day") {
                    extrafieldData[ef.field_id] =
                        new Date(ef.field_value) == "Invalid Date" ? "" : new Date(ef.field_value);
                } else if (ef.name_type == "prefix") {
                    extrafieldData[ef.field_id] =
                        ef.field_value && ef.field_value !== ""
                            ? ef.field_value.substring(ef.prefix.length, ef.length)
                            : "";
                } else if (ef.name_type == "postfix") {
                    extrafieldData[ef.field_id] =
                        ef.field_value && ef.field_value !== ""
                            ? ef.field_value.substring(0, ef.field_value.lastIndexOf(ef.postfix))
                            : "";
                } else if (ef.name_type === "time") {
                    extrafieldData[ef.field_id] = Common._formatTime(ef.field_value);
                } else if (ef.name_type === "con_type") {
                    const selectedItems = GenericContainerTypeStore._getSelectedItem(containerType);
                    if (selectedItems[ef.field_id]) {
                        extrafieldData[ef.field_id] = selectedItems[ef.field_id];
                    } else {
                        extrafieldData[ef.field_id] = ef.field_value || {};
                    }
                } else {
                    extrafieldData[ef.field_id] = ef.field_value;
                }
            });
        this._setExtraFieldRunningMapValues(extrafieldData, containerType, page);
    }

    // This function will resotre initial extrafields values to corresponding splitted transaction on SPLIT MORE option.
    _splitMoreIndex(index) {
        if (!this.reverseMap[`split-${index}`]) {
            this.reverseMap[`split-${index}`] = Common._perfectClone(
                this.reverseMap["transaction"]
            );
            this.extraFields[`split-${index}`] = Common._perfectClone(
                this.extraFields["transaction"]
            );
            this.efMapforExpressionOrComposite[`split-${index}`] = Common._perfectClone(
                this.efMapforExpressionOrComposite["transaction"]
            );
        }
        this.extrafieldRunningMap[`split-${index}`] = Common._perfectClone(
            this.initialExtrafieldValues
        );
        this.emit("change", `split-${index}`);
    }
    // This function will delete all extrafield values on deleting a particular split.
    _deleteSplittedExtrafield(index) {
        let splittedExtrafield = Common._perfectClone(this.extrafieldRunningMap);
        delete splittedExtrafield[`split-${index}`];
        Object.keys(splittedExtrafield).forEach(el => {
            //this code is for reducing the index of the remaining values in splittedExtrafield.
            if (el.includes("split") && parseInt(el.replace("split-", "")) > index) {
                splittedExtrafield[`split-${parseInt(el.replace("split-", "")) - 1}`] =
                    splittedExtrafield[`split-${parseInt(el.replace("split-", ""))}`];
                delete splittedExtrafield[`split-${parseInt(el.replace("split-", ""))}`];
            }
        });
        this.extrafieldRunningMap = Common._perfectClone(splittedExtrafield);
    }
    _returnReverseMap(con_type) {
        return this.reverseMap[con_type] || {};
    }
    _sendExpressionArrayToStore(expressionArray, id, expValid, decimalPlace, constantsArrayLength) {
        this.expressionObj[id] = expressionArray;
        this.expressionValid = expValid;
        this.decimalPlace = decimalPlace;
        this.constantsArrayLength = constantsArrayLength;
    }
    _getExpressionArray(type) {
        let prefix = `round,(`;
        let postfix = `constant_${this.constantsArrayLength},)`;
        let expression = ["("];
        if (this.decimalPlace) {
            expression.unshift(prefix);
        }
        let expObj = {};
        Array.isArray(this.expressionObj[type]) &&
            this.expressionObj[type].forEach(el => {
                if (type === "composite" && el.type !== "operator") {
                    expression.push(el.id);
                } else if (type == "expression") {
                    expression.push(el.id);
                }
                if (el.type !== "operator") {
                    expObj[el.id] = el.name;
                    if (this.decimalPlace) {
                        expObj[`constant_${this.constantsArrayLength}`] = this.decimalPlace;
                    } 
                }
            });
        expression.push(")");
        if ( this.decimalPlace ) {
            expression.push(postfix);
        }
        expObj[type] = expression.join(",");
        return expObj;
    }
    _checkExpressionValidation() {
        return this.expressionValid;
    }
    _clearConfigData() {
        this.expressionValid = false;
        this.emit("change", "clearConfig");
    }
    _removeContainerMappedField(id, con_type) {
        if (this.extrafieldRunningMap[con_type] && this.extrafieldRunningMap[con_type][id]) {
            this.extrafieldRunningMap[con_type][id] = "";
            this.extraFieldMap[con_type][id] = "";
            let contTypeExtrafield = this.reverseMap[con_type][id] || "";
            for (const item in contTypeExtrafield.additional_map) {
                if (this.extrafieldRunningMap[con_type][item]) {
                    this.extrafieldRunningMap[con_type][item] = "";
                    this.extraFieldMap[con_type][item] = "";
                    let ef = this.reverseMap[con_type][item] || "";
                    this._emptyValueOfGuardian(ef, ef.guardian, con_type);
                    this._triggerCompositeValue(con_type, item);
                }
            }
            this._emptyValueOfGuardian(contTypeExtrafield, contTypeExtrafield.guardian, con_type);
            this._triggerCompositeValue(con_type, id);
        }
        this.emit("change", "ef_data");
    }

    _setResCode() {
        this.emit("change", "delete_extra_field");
    }

    _setEfErrMsgIFSC(data) {
        this.ifscErrMsg = data;
        this.emit("change","ifscValidationFailed");
    }

    _getEfErrMsgIFSC() {
        return this.ifscErrMsg;
    }

    _setSearchableDataContentRelation(data){
        this.searchableDataContentRelation = data;
        this.emit("change","SEARCHABLE_EF_CONTENT_RELATION");
    }

    _getSearchableDataContentRelation() {
        return this.searchableDataContentRelation;
    }

    _handleActions(action) {
        switch (action.type) {
            case "CREATE_EXTRA_FIELD": {
                this._createExtraField(action.resultStr, action.res_code);
                break;
            }
            case "EDIT_EXTRA_FIELD": {
                this._editExtraField(action.resultStr, action.res_code);
                break;
            }
            case "GET_EXTRA_FIELD": {
                this._getAllExtraFieldsNew(
                    Common._sortDropdown(action.extraFields, "index_number", true),
                    action.resource,
                    action.mode,
                    action.ct_id
                );
                break;
            }
            case "DELETE_EXTRA_FIELD": {
                this._deleteExtraFields(action.resultStr, action.res_code);
                break;
            }
            case "GET_OVERRIDE_FIELD": {
                this._setOverrideFields(action.data);
                break;
            }
            case "SET_EXPRESSION_EXTRA_FIELD": {
                this._setExpressionExtraField(action.extraFields, "setObj");
                break;
            }
            case "GET_EXTRA_FIELD_TYPES": {
                this._getExtraFieldTypes(action.extraFieldsType);
                break;
            }

            case "TRANSACTION_EXTRA_FIELD": {
                this._getTransactionExtraField(action.response, action.isContainer);
                break;
            }
            case "GET_PARTICULAR_EXTRA_FIELD": {
                this._setParticluarExtraField(action.extraFields, action.resource);
                break;
            }
            case "GET_PRE_DEFINED_EXTRA_FIELD": {
                this._getPreDefinedExtraFieldTypes(action.extraFields, action.resource);
                break;
            }
            case "BUTTON_STATE": {
                this.emit("change", "BUTTON_STATE");
                break;
            }
            case "CLEAR_ALL_SEARCH_STORE": {
                this.initData();
                break;
            }
            case "CALL_IFSC": {
                this.emit("change", "CALL_IFSC", action.fId, action.response);
                break;
            }
            case "CLEAR_ALL":
            case "CLEAR_ALL_EXTRAFIELD": {
                if (action.isDaClaim)
                    this.emit("change", "transactionCreateSuccess", action.txn_id);
                this.initData();
                break;
            }
            case "SET_EF_ADMIN": {
                this.emit("change", "SET_EF_ADMIN");
                break;
            }
            case "ALL_SEARCHABLE": {
                this._setAllSearchable(action.data);
                break;
            }
            case "GET_EXTRA_FIELD_INVITE_VALUES": {
                this._setEFValuesForInvite(action.data);
                break;
            }
            case "create_extra_field": {
                this.emit("change", "create_extra_field");
                break;
            }
            case "GSTIN_SUCCESS": {
                this.emit("check", "gstinMatchSuccess", action.data, action.efId);
                break;
            }
            case "GSTIN_FAILED": {
                this.emit("check", "gstinMatchFailed", action.data, action.efId);
                break;
            }
            case "UPLOAD_MAPPINGFILE": {
                this.emit("change", "UPLOAD_MAPPINGFILE");
            }
            // break omitted
            case "delete_extra_field": {
                this._setResCode();
                break;
            }
            case "EXTRAFIELD_FAILED": {
                this.emit("change", "EXTRAFIELD_FAILED");
                break;
            }
            case "FILE_SEND": {
                this.emit("change", "extrafiledBulkUpload");
                break;
            }
            case "FILE_DOWNLOAD": { 
                this.emit("change", "extrafiledBulkDownload");
                break;
            }
            case "IFSC_FAILED": {
                this._setEfErrMsgIFSC(action.data);
                break;
            }
            case "SEARCHABLE_EF_CONTENT_RELATION": {
                this._setSearchableDataContentRelation(action.data);
                break;
            }
            default: {
                this.emit("change", action.type, action.data);
            }
        }
    }
}
const extraFieldStores = new ExtraFieldStores();
if (process.env.NODE_ENV !== "production") window.extraFieldStores = extraFieldStores;
extraFieldStores.setMaxListeners(Infinity);
dispatcher.register(extraFieldStores._handleActions.bind(extraFieldStores));
export default extraFieldStores;
